<template>
  <div class="contain">
    <div class="tcontain_left">
      <el-tree :data="menuData" :props="defaultProps" node-key="id" :default-expanded-keys="defaultExpandedKeys"
        @node-click="handleNodeClick" ref="menutree" highlight-current></el-tree>
    </div>
    <div class="contain_right">
      <div class="contain_right_up">
        <div class="containrigthup_left">
          <!-- 精度选择框 -->
          <div class="containrightupleft_top">
            <!-- 深度行情布局图标 -->
            <div :class="layoutMoudle == 0 ? 'depth_layout background_position1' : 'depth_layout background_position4'"
              @click="choseLayoutModel(0)"></div>
            <div :class="layoutMoudle == 1 ? 'depth_layout background_position2' : 'depth_layout background_position6'"
              @click="choseLayoutModel(1)"></div>
            <div :class="layoutMoudle == 2 ? 'depth_layout background_position3' : 'depth_layout background_position5'"
              @click="choseLayoutModel(2)"></div>
            <div class="depth_precision">
              <el-dropdown size="mini" @command="handlePricePrecision">
                <span class="el-dropdown-link">
                  {{ selectedPricePrecision }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">{{
                    currencySymbol.pricePrecisionArr[0] }}</el-dropdown-item>
                  <el-dropdown-item command="1">{{
                    currencySymbol.pricePrecisionArr[1] }}</el-dropdown-item>
                  <el-dropdown-item command="2">{{
                    currencySymbol.pricePrecisionArr[2] }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <!-- 深度行情表头 -->
          <div class="containrightupleft_head">
            <div class="containrightupleft_head1">{{ quoteTabelLabel }}</div>
            <div class="containrightupleft_head2">{{ baseTabelLabel }}</div>
            <div class="containrightupleft_head3">
              <el-dropdown size="mini" @command="handleTotal">
                <span class="el-dropdown-link">
                  {{ selectedTotal === 0 ? totalTabelLabel : totalAmountTabelLabel }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">{{ totalTabelLabel }}</el-dropdown-item>
                  <el-dropdown-item command="1">{{ totalAmountTabelLabel }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="layoutModule_shell" :style="{ 'z-index': layoutMoudle == 0 ? 1 : -1 }">
            <div class="containrightupleft_up fontSize11">
              <!-- 卖盘深度 -->
              <el-table ref="askTableRef" :data="askTableData" class="widthP100 fontSize11"
                :row-style="{ height: '10px' }" :cell-style="{ padding: '0px' }" max-height="222" size="mini"
                highlight-current-row :show-header="false" @current-change="askTableHandleCurrentChange">
                <el-table-column prop="price" v-bind:label="quoteTabelLabel" class="width120">
                  <template slot-scope="scope">
                    <div style="color: red; font-weight: bold">
                      {{ scope.row.price }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="qty" v-bind:label="baseTabelLabel" width="110"></el-table-column>
                <el-table-column v-if="showTotal" prop="total" v-bind:label="totalTabelLabel"
                  width="120"></el-table-column>
                <el-table-column v-if="showAmountTotal" prop="totalAmount" v-bind:label="totalAmountTabelLabel"
                  width="120"></el-table-column>
              </el-table>
            </div>
            <div class="containrightupleft_mid"></div>
            <div class="containrightupleft_down">
              <!-- 买盘深度 -->
              <el-table :data="bidTableData" class="widthP100 fontSize11" :row-style="{ height: '10px' }"
                :cell-style="{ padding: '0px' }" max-height="222" size="mini" highlight-current-row :show-header="false"
                @current-change="askTableHandleCurrentChange">
                <el-table-column prop="price" v-bind:label="quoteTabelLabel">
                  <template slot-scope="scope">
                    <div style="color: green; font-weight: bold">
                      {{ scope.row.price }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="qty" v-bind:label="baseTabelLabel" width="110"></el-table-column>
                <el-table-column v-if="showTotal" prop="total" v-bind:label="totalTabelLabel"
                  width="120"></el-table-column>
                <el-table-column v-if="showAmountTotal" prop="totalAmount" v-bind:label="totalAmountTabelLabel"
                  width="120"></el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 全显示卖盘深度 -->
          <div class="layoutModule_shell" :style="{ 'z-index': layoutMoudle == 1 ? 1 : -1 }">
            <div class="containrightupleft_all fontSize11">
              <!-- 卖盘深度 -->
              <el-table ref="askTableRef1" :data="askTableData" class="widthP100 fontSize11"
                :row-style="{ height: '15px' }" :cell-style="{ padding: 0 }" max-height="450" size="mini"
                highlight-current-row :show-header="false" @current-change="askTableHandleCurrentChange">
                <el-table-column prop="price" v-bind:label="quoteTabelLabel" class="width120">
                  <template slot-scope="scope">
                    <div style="color: red; font-weight: bold">
                      {{ scope.row.price }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="qty" v-bind:label="baseTabelLabel" width="110"></el-table-column>
                <el-table-column v-if="showTotal" prop="total" v-bind:label="totalTabelLabel"
                  width="120"></el-table-column>
                <el-table-column v-if="showAmountTotal" prop="totalAmount" v-bind:label="totalAmountTabelLabel"
                  width="120"></el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 全显示买盘深度 -->
          <div class="layoutModule_shell" :style="{ 'z-index': layoutMoudle == 2 ? 1 : -1 }">
            <div class="containrightupleft_all">
              <!-- 买盘深度 -->
              <el-table :data="bidTableData" class="widthP100 fontSize11" :row-style="{ height: '15px' }"
                :cell-style="{ padding: '0' }" max-height="450" size="mini" highlight-current-row :show-header="false"
                @current-change="askTableHandleCurrentChange">
                <el-table-column prop="price" v-bind:label="quoteTabelLabel">
                  <template slot-scope="scope">
                    <div style="color: green; font-weight: bold">
                      {{ scope.row.price }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="qty" v-bind:label="baseTabelLabel" width="110"></el-table-column>
                <el-table-column v-if="showTotal" prop="total" v-bind:label="totalTabelLabel"
                  width="120"></el-table-column>
                <el-table-column v-if="showAmountTotal" prop="totalAmount" v-bind:label="totalAmountTabelLabel"
                  width="120"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="containrigthup_right">
          <div class="containrigthupright_up">
            <div class="accounttext">
              账户：{{ selectedSymbolObj.apiAlias }}
            </div>
            <div class="markettext">
              交易所：{{ selectedSymbolObj.exchangeName }}
              <!-- <span v-if="selectedSymbolObj.exchange === 1">KUCOIN</span>
              <span v-if="selectedSymbolObj.exchange === 2">OKEX</span>
              <span v-if="selectedSymbolObj.exchange === 3">BINANCE</span>
              <span v-if="selectedSymbolObj.exchange === 4">BITMART</span>
              <span v-if="selectedSymbolObj.exchange === 5">GATEIO</span>
              <span v-if="selectedSymbolObj.exchange === 6">BITRUE</span>
              <span v-if="selectedSymbolObj.exchange === 7">LBANK</span>
              <span v-if="selectedSymbolObj.exchange === 8">HUOBI</span>
              <span v-if="selectedSymbolObj.exchange === 9">COINONE</span>
              <span v-if="selectedSymbolObj.exchange === 10">MXC</span>
              <span v-if="selectedSymbolObj.exchange === 11">HOO</span>
              <span v-if="selectedSymbolObj.exchange === 12">COINW</span>
              <span v-if="selectedSymbolObj.exchange === 13">BITWELL</span>
              <span v-if="selectedSymbolObj.exchange === 14">BYBIT</span> -->
            </div>
            <div class="orderconfirmtext">
              <el-checkbox v-model="confirmChecked" @change="confirmChange">Show Order Confirm</el-checkbox>
            </div>
          </div>
          <div class="containrigthupright_down">
            <div class="trade_left">
              <el-tabs v-model="activeTradeTab" type="border-card" class="trade-tabs" style="height: 100%;">
                <el-tab-pane label="买入" name="order">
                  <!-- <div class="tradeleftIn"> -->
                    <!--价格行  -->
                    <div class="tradeIn1" style="margin-top: 4px;">
                      <div class="trade_up">
                        <div class="tradeup_left">
                          <div>
                            <div>价格</div>
                            <div>{{ selectedSymbolObj.quoteCurrency }}</div>
                          </div>
                        </div>
                        <div class="tradeup_right">
                          <el-input-number style="width: 300px; background-color: #020432" v-model="buyPrice"
                            size="medium" :disabled="buyPriceDisable" controls-position="right"
                            @change="onBuyPriceInputChange" @focus="onBuyPriceInputFocus"
                            :precision="currencySymbol.pricePrecision" :step="currencySymbol.priceIncrease"
                            :min="0"></el-input-number>
                        </div>
                      </div>
                      <div class="trade_down">
                        <div class="tradedown_left"></div>
                        <div class="tradedown_right">
                          <div class="tradedownright_left">
                            <!-- <el-link @click="onBuyMarketPriceClick" class="link" type="warning">
                        市价
                      </el-link>
                      <el-link @click="onBuyCompetitorsPriceClick" class="link" type="warning">
                        对手价
                      </el-link>
                      <el-link @click="onBuyLimitPriceClick" class="link" type="warning">
                        挂单价
                      </el-link> -->
                            <el-radio-group v-model="buyPriceType" size="mini" @change="buyPriceTypeChange">
                              <el-radio-button :label="1">市价</el-radio-button>
                              <el-radio-button :label="2">对手价</el-radio-button>
                              <el-radio-button :label="3">挂单价</el-radio-button>
                              <el-radio-button :label="4">超价</el-radio-button>
                            </el-radio-group>
                          </div>
                          &nbsp;&nbsp;
                          <el-checkbox v-model="buyfollow" :disabled="buydis">跟随</el-checkbox>
                        </div>
                      </div>
                    </div>
                    <div class="tradeIn1">
                      <div class="trade_up">
                        <div class="tradeup_left">
                          <div>
                            <div>数量</div>
                            <div>{{ selectedSymbolObj.baseCurrency }}</div>
                          </div>
                        </div>
                        <div class="tradeup_right">
                          <el-input-number style="width: 300px" v-model="buyNumValue" size="medium" ref="inputNumberRef"
                            :disabled="buyNumDisable" controls-position="right" @change="onBuyNumInputChange"
                            :precision="myPrecision" :step="currencySymbol.baseIncrease" :min="0"></el-input-number>
                        </div>
                      </div>
                      <div class="trade_down">
                        <div class="tradedown_left"></div>
                        <div class="tradedown_right">
                          <!-- <el-link class="link" type="warning"> 10% </el-link>
                      <el-link class="link" type="warning"> 25% </el-link>
                      <el-link class="link" type="warning"> 30% </el-link>
                      <el-link class="link" type="warning"> 50% </el-link>
                      <el-link class="link" type="warning"> MAX </el-link> -->
                          <el-radio-group v-model="buyNumType" size="mini" @change="buyNumTypeChange">
                            <el-radio-button :label="1">10%</el-radio-button>
                            <el-radio-button :label="2">25%</el-radio-button>
                            <el-radio-button :label="3">30%</el-radio-button>
                            <el-radio-button :label="4">50%</el-radio-button>
                            <el-radio-button :label="5">MAX</el-radio-button>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                    <div class="tradeIn1">
                      <div class="trade_up">
                        <div class="tradeup_left">
                          <div>
                            <div>金额</div>
                            <div>{{ selectedSymbolObj.quoteCurrency }}</div>
                          </div>
                        </div>
                        <div class="tradeup_right">
                          <el-input-number style="width: 300px" v-model="buyAmount" :disabled="buyAmountDisable"
                            size="medium" controls-position="right" @change="onBuyAmountInputChange"
                            :precision="currencySymbol.amountPrecision" :step="currencySymbol.amountIncrease"
                            :min="0"></el-input-number>
                        </div>
                      </div>
                      <div class="trade_down">
                        <div class="tradedown_left"></div>
                        <div class="tradedown_right">
                          <el-link type="success" :underline="false">
                            可用余额({{ selectedSymbolObj.quoteCurrency }}):{{
                              selectedSymbolObj.quoteCurrencyAvailable
                            }}</el-link>
                        </div>
                      </div>
                    </div>
                    <div class="tradeIn4">
                      <el-radio-group v-model="buyTypeRadio" @change="buyTypeRadioChange">
                        <el-radio label="GTC">GTC</el-radio>
                        <el-radio label="GTT">GTT</el-radio>
                        <el-radio label="IOC">IOC</el-radio>
                        <el-radio label="FOK">FOK</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="tradeIn5">
                      <!-- <el-radio v-model="buyPostOnly" label="1" :disabled="buyPostOnlyDisabled">Post Only</el-radio> -->
                      <el-checkbox v-model="buyPostOnly" :disabled="buyPostOnlyDisabled">Post Only</el-checkbox>
                      <el-checkbox v-model="buyReduceOnly">Reduce Only</el-checkbox>
                      <el-checkbox v-model="buyHiddenChecked" @change="buyHiddenChange">Hidden</el-checkbox>
                    </div>

                    <!-- <div class="tradeIn6">
                      <el-checkbox v-model="buyHiddenChecked" @change="buyHiddenChange">Hidden</el-checkbox>
                    </div> -->

                    <div class="tradeIn7">
                      <el-checkbox v-model="buyIcebergChecked" :disabled="buyIcebergCheckedDisabled"
                        @change="icebergChange">Iceberg
                      </el-checkbox>
                      <el-input v-model="buyIcebergNum" size="mini" :disabled="buyIcebergNumDisabled"
                        style="width: 100px; margin-left: 12px" placeholder="冰山单数量"></el-input>

                    </div>
                    <div class="tradeIn8">
                      <!-- 超价点位 -->
                      <span style="color: rgba(255, 255, 255, 0.75)">超价点位:</span>
                      <el-input v-model="buySuperPriceNum" size="mini" :disabled="buySuperPriceNumDisabled"
                        style="width: 100px; margin-left: 12px;margin-top: 5px;" placeholder="超价点位"
                        controls-position="right" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                    </div>
                    <!-- 买入按钮 -->
                    <div class="tradeBtn">
                      <el-button type="success" style="width: 200px;margin-top: 28px;" @click="buyClick">买入</el-button>
                    </div>
                  <!-- </div> -->
                </el-tab-pane>

                <!-- 拆单 Tab -->
                <el-tab-pane label="拆单" name="split" @tab-click="initSplitPrice">
                  <div class="tradeitem1" style="margin-top: 1px;">
                    <div class="trade_up">
                      <div class="tradeup_left2">
                        <div>
                          <div>价格区间</div>
                          <div>{{ selectedSymbolObj.quoteCurrency }}</div>
                        </div>
                      </div>
                      <div class="tradeup_right" style="width: 300px; display: flex; align-items: center;">
                        <el-input-number style="flex: 1; background-color: #020432" v-model="splitForm.startPrice"
                          size="small" @change="useSplitFun" controls-position="right"
                          :precision="currencySymbol.pricePrecision" :step="currencySymbol.priceIncrease" :min="0"
                          placeholder="开始价格"></el-input-number>
                        <span style="color: rgba(255, 255, 255, 0.75); margin: 0 10px;">-</span>
                        <el-input-number style="flex: 1; background-color: #020432" v-model="splitForm.endPrice"
                          size="small" @change="useSplitFun" controls-position="right"
                          :precision="currencySymbol.pricePrecision" :step="currencySymbol.priceIncrease" :min="0"
                          placeholder="结束价格"></el-input-number>
                      </div>
                    </div>
                  </div>
                  <div class="tradeitem1">
                    <div class="trade_up">
                      <div class="tradeup_left2">
                        <div>
                          <div>数量</div>
                          <div>{{ selectedSymbolObj.baseCurrency }}</div>
                        </div>
                      </div>
                      <div class="tradeup_right">
                        <el-input-number style="width: 300px; background-color: #020432" v-model="splitForm.amount"
                          size="small" @change="useSplitFun" controls-position="right" :precision="myPrecision"
                          :step="currencySymbol.baseIncrease" :min="0" placeholder="数量"></el-input-number>
                      </div>
                    </div>
                  </div>
                  <div class="tradeitem1">
                    <div class="trade_up">
                      <div class="tradeup_left2">
                        <div>
                          <div>订单数量</div>
                        </div>
                      </div>
                      <div class="tradeup_right">
                        <el-input-number style="width: 300px; background-color: #020432" v-model="splitForm.orderCount"
                          size="small" @change="useSplitFun" controls-position="right" :min="2" :max="100"
                          placeholder="订单数量"></el-input-number>
                      </div>
                    </div>
                  </div>
                  <div class="tradeitem1">
                    <div class="trade_up">
                      <div class="tradeup_left2">
                        <div>
                          <div>数量浮动%</div>
                        </div>
                      </div>
                      <div class="tradeup_right">
                        <el-input-number style="width: 300px; background-color: #020432" v-model="countFloat"
                          size="small" @change="useSplitFun" controls-position="right" :min="0" :max="100"
                          placeholder="数量浮动%"></el-input-number>
                      </div>
                    </div>
                  </div>
                  <div class="split-table" >
                    <div style="height: 160px; overflow-y: auto;">
                      <el-table :data="splitOrders"  size="small" :row-style="{ height: '24px' }" :cell-style="{ padding: '0' }">
                        <el-table-column prop="price" label="价格"></el-table-column>
                        <el-table-column prop="amount" label="数量"></el-table-column>
                        <el-table-column prop="percentage" label="百分比">
                          <template slot-scope="scope">
                            {{ scope.row.percentage }}%
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                  <div class="split-summary">
                    <div class="summary-item">
                      <span class="summary-label">入场均价:</span>
                      <span class="summary-value">{{ splitSummary.avgPrice }}</span>
                    </div>
                    <div class="summary-item">
                      <span class="summary-label">成本:</span>
                      <span class="summary-value">{{ splitSummary.totalCost }}</span>
                    </div>
                  </div>
                  <!-- 拆单买入按钮 -->
                  <div class="tradeBtn">
                    <el-button type="success" style="width: 200px;margin-top: 14px;" @click="splitBuyClick">买入</el-button>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="trade_right">
              <el-tabs v-model="activeTradeTabTwo" type="border-card" class="trade-tabs" style="height: 100%;">
                <el-tab-pane label="卖出" name="order">
                    <div class="tradeIn1" style="margin-top: 4px;">
                      <div class="trade_up">
                        <div class="tradeup_left">
                          <div>
                            <div>价格</div>
                            <div>{{ selectedSymbolObj.quoteCurrency }}</div>
                          </div>
                        </div>
                        <div class="tradeup_right">
                          <el-input-number style="width: 300px" v-model="sellPrice" :disabled="sellPriceDisable"
                            size="medium" controls-position="right" @change="onSellPriceInputChange"
                            @focus="onSellPriceInputFocus" :precision="currencySymbol.pricePrecision"
                            :step="currencySymbol.priceIncrease" :min="0"></el-input-number>
                        </div>
                      </div>
                      <div class="trade_down">
                        <div class="tradedown_left"></div>
                        <div class="tradedown_right">
                          <div class="tradedownright_left">
                            <el-radio-group v-model="sellPriceType" size="mini" @change="sellPriceTypeChange">
                              <el-radio-button :label="1">市价</el-radio-button>
                              <el-radio-button :label="2">对手价</el-radio-button>
                              <el-radio-button :label="3">挂单价</el-radio-button>
                              <el-radio-button :label="4">超价</el-radio-button>
                            </el-radio-group>
                          </div>
                          &nbsp;&nbsp;
                          <el-checkbox v-model="sellfollow" :disabled="selldis">跟随</el-checkbox>
                        </div>
                      </div>
                    </div>
                    <div class="tradeIn1">
                      <div class="trade_up">
                        <div class="tradeup_left">
                          <div>
                            <div>数量</div>
                            <div>{{ selectedSymbolObj.baseCurrency }}</div>
                          </div>
                        </div>
                        <div class="tradeup_right">
                          <el-input-number style="width: 300px" v-model="sellNum" size="medium"
                            controls-position="right" @change="onSellNumInputChange"
                            :precision="currencySymbol.basePrecision" :step="currencySymbol.baseIncrease" :min="0">
                          </el-input-number>
                        </div>
                      </div>
                      <div class="trade_down">
                        <div class="tradedown_left"></div>
                        <div class="tradedown_right">
                          <el-radio-group v-model="sellNumType" size="mini" @change="sellNumTypeChange">
                            <el-radio-button :label="1">10%</el-radio-button>
                            <el-radio-button :label="2">25%</el-radio-button>
                            <el-radio-button :label="3">30%</el-radio-button>
                            <el-radio-button :label="4">50%</el-radio-button>
                            <el-radio-button :label="5">MAX</el-radio-button>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                    <div class="tradeIn1">
                      <div class="trade_up">
                        <div class="tradeup_left">
                          <div>
                            <div>金额</div>
                            <div>{{ selectedSymbolObj.quoteCurrency }}</div>
                          </div>
                        </div>
                        <div class="tradeup_right">
                          <el-input-number style="width: 300px" v-model="sellAmount" :disabled="sellAmountDisable"
                            size="medium" controls-position="right" @change="onSellAmountInputChange"
                            :precision="currencySymbol.amountPrecision" :step="currencySymbol.amountIncrease"
                            :min="0"></el-input-number>
                        </div>
                      </div>
                      <div class="trade_down">
                        <div class="tradedown_left"></div>
                        <div class="tradedown_right">
                          <el-link type="success" :underline="false">
                            可用数量({{ selectedSymbolObj.baseCurrency }}):{{ selectedSymbolObj.baseCurrencyAvailable
                            }}</el-link>
                        </div>
                      </div>
                    </div>
                    <div class="tradeIn4">
                      <el-radio-group v-model="sellTypeRadio" @change="sellTypeRadioChange">
                        <el-radio label="GTC">GTC</el-radio>
                        <el-radio label="GTT">GTT</el-radio>
                        <el-radio label="IOC">IOC</el-radio>
                        <el-radio label="FOK">FOK</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="tradeIn5">
                      <el-checkbox v-model="sellPostOnly" :disabled="sellPostOnlyDisabled">Post Only</el-checkbox>
                      <el-checkbox v-model="sellReduceOnly">Reduce Only</el-checkbox>
                      <el-checkbox v-model="sellHiddenChecked" @change="sellHiddenChange">Hidden</el-checkbox>
                    </div>
                    <!-- <div class="tradeIn6">
                      <el-checkbox v-model="sellHiddenChecked" @change="sellHiddenChange">Hidden</el-checkbox>
                    </div> -->
                    <div class="tradeIn7">
                      <el-checkbox v-model="sellIcebergChecked" :disabled="sellIcebergCheckedDisabled"
                        @change="sellIcebergChange">
                        Iceberg</el-checkbox>
                      <el-input v-model="sellIcebergNum" size="mini" :disabled="sellIcebergNumDisabled"
                        style="width: 100px; margin-left: 12px" placeholder="冰山单数量"></el-input>

                    </div>
                    <div class="tradeIn8">
                      <!-- 超价点位 -->
                      <span style="color: rgba(255, 255, 255, 0.75)">超价点位:</span>
                      <el-input v-model="sellSuperPriceNum" size="mini" :disabled="sellSuperPriceNumDisabled"
                        style="width: 100px; margin-left: 12px;margin-top: 5px;" placeholder="超价点位"
                        controls-position="right" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                    </div>
                    <!-- 卖出按钮 -->
                    <div class="tradeBtn">
                      <el-button type="danger" style="width: 200px;margin-top: 28px;" @click="sellClick">卖出</el-button>
                    </div>
                </el-tab-pane>

                <!-- 拆单 Tab -->
                <el-tab-pane label="拆单" name="split" @tab-click="initSplitPrice">
                  <div class="tradeitem1" style="margin-top: 1px;">
                    <div class="trade_up">
                      <div class="tradeup_left2">
                        <div>
                          <div>价格区间</div>
                          <div>{{ selectedSymbolObj.quoteCurrency }}</div>
                        </div>
                      </div>
                      <div class="tradeup_right" style="width: 300px; display: flex; align-items: center;">
                        <el-input-number style="flex: 1; background-color: #020432" v-model="splitForm.startPrice"
                          size="small" @change="useSplitFun" controls-position="right"
                          :precision="currencySymbol.pricePrecision" :step="currencySymbol.priceIncrease" :min="0"
                          placeholder="开始价格"></el-input-number>
                        <span style="color: rgba(255, 255, 255, 0.75); margin: 0 10px;">-</span>
                        <el-input-number style="flex: 1; background-color: #020432" v-model="splitForm.endPrice"
                          size="small" @change="useSplitFun" controls-position="right"
                          :precision="currencySymbol.pricePrecision" :step="currencySymbol.priceIncrease" :min="0"
                          placeholder="结束价格"></el-input-number>
                      </div>
                    </div>
                  </div>
                  <div class="tradeitem1">
                    <div class="trade_up">
                      <div class="tradeup_left2">
                        <div>
                          <div>数量</div>
                          <div>{{ selectedSymbolObj.baseCurrency }}</div>
                        </div>
                      </div>
                      <div class="tradeup_right">
                        <el-input-number style="width: 300px; background-color: #020432" v-model="splitForm.amount"
                          size="small" @change="useSplitFun" controls-position="right" :precision="myPrecision"
                          :step="currencySymbol.baseIncrease" :min="0" placeholder="数量"></el-input-number>
                      </div>
                    </div>
                  </div>
                  <div class="tradeitem1">
                    <div class="trade_up">
                      <div class="tradeup_left2">
                        <div>
                          <div>订单数量</div>
                        </div>
                      </div>
                      <div class="tradeup_right">
                        <el-input-number style="width: 300px; background-color: #020432" v-model="splitForm.orderCount"
                          size="small" @change="useSplitFun" controls-position="right" :min="2" :max="100"
                          placeholder="订单数量"></el-input-number>
                      </div>
                    </div>
                  </div>
                  <div class="tradeitem1">
                    <div class="trade_up">
                      <div class="tradeup_left2">
                        <div>
                          <div>数量浮动%</div>
                        </div>
                      </div>
                      <div class="tradeup_right">
                        <el-input-number style="width: 300px; background-color: #020432" v-model="countFloat"
                          size="small" @change="useSplitFun" controls-position="right" :min="0" :max="100"
                          placeholder="数量浮动%"></el-input-number>
                      </div>
                    </div>
                  </div>
                  <div class="split-table">
                    <div style="height: 160px; overflow-y: auto;">
                      <el-table :data="splitOrders" size="small" :row-style="{ height: '24px' }" :cell-style="{ padding: '0' }">
                        <el-table-column prop="price" label="价格"></el-table-column>
                        <el-table-column prop="amount" label="数量"></el-table-column>
                        <el-table-column prop="percentage" label="百分比">
                          <template slot-scope="scope">
                            {{ scope.row.percentage }}%
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                  <div class="split-summary">
                    <div class="summary-item">
                      <span class="summary-label">入场均价:</span>
                      <span class="summary-value">{{ splitSummary.avgPrice }}</span>
                    </div>
                    <div class="summary-item">
                      <span class="summary-label">成本:</span>
                      <span class="summary-value">{{ splitSummary.totalCost }}</span>
                    </div>
                  </div>
                  <!-- 卖出按钮 -->
                  <div class="tradeBtn">
                    <el-button type="danger" style="width: 200px;margin-top: 14px;" @click="splitSellClick">卖出</el-button>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
      <div class="contain_right_down" id="tableDiv">
        <el-tabs v-model="activetabName" @tab-click="tabHandleClick">
          <el-tab-pane label="委托" name="first">
            <el-table ref="orderTableData" :data="orderTableData" :row-style="{ height: '35px' }"
              :cell-style="{ padding: '0' }" :height="tableHeight" highlight-current-row
              @current-change="handleCurrentChange" @filter-change="filterChange">
              <el-table-column prop="id" label="委托编号" width="210">
                <template slot-scope="scope">
                  {{ scope.row.id === "" ? "--" : scope.row.id }}
                </template>
              </el-table-column>
              <el-table-column prop="createAt" label="委托时间" width="180">
                <template slot-scope="scope">
                  {{ scope.row.createAt === "" ? "--" : scope.row.createAt }}
                </template>
              </el-table-column>
              <el-table-column prop="symbol" label="交易对" width="120">
                <template slot-scope="scope">
                  {{ scope.row.symbol === "" ? "--" : scope.row.symbol }}
                </template>
              </el-table-column>
              <el-table-column prop="side" label="方向" width="80" :filters="[
                { text: '买', value: 'buy' },
                { text: '卖', value: 'sell' },]
                " column-key="side">
                <template slot-scope="scope">
                  <span v-if="scope.row.side == 'buy'" style="color: green">买</span>
                  <span v-if="scope.row.side == 'sell'" style="color: red">卖</span>
                </template>
              </el-table-column>
              <el-table-column prop="opType" label="状态">
                <template slot-scope="scope">
                  {{ scope.row.opType === "" ? "--" : scope.row.opType }}
                </template>
              </el-table-column>
              <el-table-column prop="size" label="委托数量">
                <template slot-scope="scope">
                  {{ scope.row.size === "" ? "--" : scope.row.size }}
                </template>
              </el-table-column>
              <el-table-column prop="dealSize" label="成交数量">
                <template slot-scope="scope">
                  {{ scope.row.dealSize === "" ? "--" : scope.row.dealSize }}
                </template>
              </el-table-column>
              <el-table-column prop="price" label="委托价格">
                <template slot-scope="scope">
                  {{ scope.row.price === "" ? "--" : scope.row.price }}
                </template>
              </el-table-column>
              <el-table-column prop="funds" label="委托金额">
                <template slot-scope="scope">
                  {{ scope.row.funds === "" ? "--" : scope.row.funds }}
                </template>
              </el-table-column>
              <el-table-column prop="type" label="类型" width="100">
                <template slot-scope="scope">
                  {{ scope.row.type === "" ? "--" : "" }}
                  <span v-if="scope.row.type == 'limit'">限价单</span>
                  <span v-if="scope.row.type == 'market'">市价单</span>
                </template>
              </el-table-column>
              <el-table-column prop="hidden" label="隐藏" width="80">
                <template slot-scope="scope">
                  {{ scope.row.hidden === "" ? "--" : "" }}
                  <span v-if="scope.row.hidden == false" style="color: green">否</span>
                  <span v-if="scope.row.hidden == true" style="color: red">是</span>
                </template>
              </el-table-column>
              <el-table-column prop="visibleSize" label="冰山单" width="80">
                <template slot-scope="scope">
                  {{ scope.row.visibleSize === "" ? "--" : scope.row.visibleSize }}
                </template>
              </el-table-column>
            </el-table>
            <!-- <el-pagination layout="prev, pager, next " @current-change="handleOrderPageChange" :page-size="pageConfig.pageSize"
              :total="pageConfig.totalNum" :current-page="pageConfig.currentPage">
            </el-pagination> -->
            <el-button size="mini" @click="getFirstPage()">首页</el-button>
            <el-button size="mini" @click="getLastPage()">上一页</el-button>
            <el-button size="mini" @click="getNextPage()">下一页</el-button>
          </el-tab-pane>
          <el-tab-pane label="成交" name="second">
            <el-table ref="fillsTableData" :data="fillsTableData" :row-style="{ height: '35px' }"
              :cell-style="{ padding: '0' }" :height="tableHeight" @filter-change="filterChange">
              <el-table-column prop="orderId" label="委托编号" width="210">
                <template slot-scope="scope">
                  {{ scope.row.orderId === "" ? "--" : scope.row.orderId }}
                </template>
              </el-table-column>
              <el-table-column prop="tradeId" label="成交编号" width="150">
                <template slot-scope="scope">
                  {{ scope.row.tradeId === "" ? "--" : scope.row.tradeId }}
                </template>
              </el-table-column>
              <el-table-column prop="createAt" label="成交时间" width="150">
                <template slot-scope="scope">
                  {{ scope.row.createAt === "" ? "--" : scope.row.createAt }}
                </template>
              </el-table-column>
              <el-table-column prop="ordercreateAt" label="委托时间" width="180">
                <template slot-scope="scope">
                  {{ scope.row.ordercreateAt === "" ? "--" : scope.row.ordercreateAt }}
                </template>
              </el-table-column>
              <el-table-column prop="symbol" label="交易对" width="150">
                <template slot-scope="scope">
                  {{ scope.row.symbol === "" ? "--" : scope.row.symbol }}
                </template>
              </el-table-column>
              <el-table-column prop="side" label="方向" width="80"
                :filters="[{ text: '买', value: 'buy' }, { text: '卖', value: 'sell' },]" column-key="side">
                <template slot-scope="scope">
                  <span v-if="scope.row.side == 'buy'" style="color: green">买</span>
                  <span v-if="scope.row.side == 'sell'" style="color: red">卖</span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="tradeType" label="类型"> </el-table-column> -->
              <el-table-column prop="size" label="成交数量">
                <template slot-scope="scope">
                  {{ scope.row.size === "" ? "--" : scope.row.size }}
                </template>
              </el-table-column>
              <el-table-column prop="price" label="成交价格">
                <template slot-scope="scope">
                  {{ scope.row.price === "" ? "--" : scope.row.price }}
                </template>
              </el-table-column>
              <el-table-column prop="funds" label="成交金额">
                <template slot-scope="scope">
                  {{ scope.row.funds === "" ? "--" : scope.row.funds }}
                </template>
              </el-table-column>
              <el-table-column prop="fee" label="手续费">
                <template slot-scope="scope">
                  {{ scope.row.fee === "" ? "--" : scope.row.fee }}
                </template>
              </el-table-column>
              <el-table-column prop="feeCurrency" label="计费币种">
                <template slot-scope="scope">
                  {{ scope.row.symbol === "" ? "--" : scope.row.feeCurrency }}
                </template>
              </el-table-column>
              <el-table-column prop="type" label="类型" width="80">
                <template slot-scope="scope">
                  {{ scope.row.type === "" ? "--" : "" }}
                  <span v-if="scope.row.type == 'limit'">限价单</span>
                  <span v-if="scope.row.type == 'market'">市价单</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- <el-pagination layout="prev, pager, next " @current-change="handleFillsPageChange"
              :page-size="pageConfig.pageSize" :total="pageConfig.ftotalNum" :current-page="pageConfig.fcurrentPage">
            </el-pagination> -->
            <el-button size="mini" @click="getFirstPage()">首页</el-button>
            <el-button size="mini" @click="getLastPage()">上一页</el-button>
            <el-button size="mini" @click="getNextPage()">下一页</el-button>
          </el-tab-pane>
          <el-tab-pane label="资产" name="third">
            <el-tabs v-model="accounttabName" @tab-click="accounttabClick">
              <el-tab-pane label="资产余额" name="fourth">
                <el-table :data="accountTableData" :row-style="{ height: '35px' }" :cell-style="{ padding: '0' }"
                  :height="tableHeight - 15">
                  <el-table-column prop="currency" label="币种" width="180">
                  </el-table-column>
                  <el-table-column prop="balance" label="数量" width="240">
                  </el-table-column>
                  <el-table-column prop="available" label="可用">
                  </el-table-column>
                  <el-table-column prop="holds" label="冻结"> </el-table-column>
                  <el-table-column prop="type" label="类型"> </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="资产划转" name="fifth">
                <el-table :data="transferTableData" :row-style="{ height: '35px' }" :cell-style="{ padding: '0' }"
                  :height="tableHeight - 15">
                  <el-table-column prop="currency" label="币种" width="180">
                  </el-table-column>
                  <el-table-column label="划转数量" prop="amount" width="240">
                    <template slot-scope="scope">
                      <el-col :span="12">
                        <el-input size="mini" v-model="scope.row.amount"></el-input>
                      </el-col>
                    </template>
                  </el-table-column>
                  <el-table-column label="划转方向" prop="direct" width="220">
                    <template slot-scope="scope">
                      <el-col :span="15">
                        <el-select size="mini" v-model="scope.row.direct" clearable>
                          <el-option label="储蓄转交易" value="0"></el-option>
                          <el-option label="交易转储蓄" value="1"></el-option>
                        </el-select>
                      </el-col>
                    </template>
                  </el-table-column>
                  <el-table-column label="划转确认">
                    <template slot-scope="scope">
                      <el-button size="small" @click="InnerTransfer(scope.$index, scope.row)">确认</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="账薄" name="sixth">
                <el-tabs v-model="rechargetabName" @tab-click="rechargetabClick">
                  <el-tab-pane label="充值记录" name="seventh">
                    <el-table :data="depositTableData" :row-style="{ height: '35px' }" :cell-style="{ padding: '0' }"
                      :height="tableHeight - 86">
                      <el-table-column prop="currency" label="币种">
                        <template slot-scope="scope">
                          {{ scope.row.currency === "" ? "--" : scope.row.currency }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="amount" label="充值金额">
                        <template slot-scope="scope">
                          {{ scope.row.amount === "" ? "--" : scope.row.amount }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="fee" label="充值手续费">
                        <template slot-scope="scope">
                          {{ scope.row.fee === "" ? "--" : scope.row.fee }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="status" label="是否为平台内部充值" width="200">
                        <template slot-scope="scope">
                          {{ scope.row.status === "" ? "--" : scope.row.status }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="remark" label="钱包交易id">
                        <template slot-scope="scope">
                          {{ scope.row.remark === "" ? "--" : scope.row.remark }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                          {{ scope.row.status === "" ? "--" : scope.row.status }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="remark" label="备注">
                        <template slot-scope="scope">
                          {{ scope.row.remark === "" ? "--" : scope.row.remark }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="createAt" label="创建时间">
                        <template slot-scope="scope">
                          {{ scope.row.createAt === "" ? "--" : scope.row.createAt }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="updateAt" label="修改时间">
                        <template slot-scope="scope">
                          {{ scope.row.updateAt === "" ? "--" : scope.row.updateAt }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                  <el-tab-pane label="提现记录" name="eighth">
                    <el-table :data="withdrawTableData" :row-style="{ height: '35px' }" :cell-style="{ padding: '0' }"
                      :height="tableHeight - 86">
                      <el-table-column prop="currency" label="币种">
                        <template slot-scope="scope">
                          {{ scope.row.currency === "" ? "--" : scope.row.currency }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="amount" label="提现金额">
                        <template slot-scope="scope">
                          {{ scope.row.amount === "" ? "--" : scope.row.amount }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="fee" label="提现手续费">
                        <template slot-scope="scope">
                          {{ scope.row.fee === "" ? "--" : scope.row.fee }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="status" label="是否为平台内部提现" width="200">
                        <template slot-scope="scope">
                          {{ scope.row.status === "" ? "--" : scope.row.status }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="status" label="钱包交易id">
                        <template slot-scope="scope">
                          {{ scope.row.status === "" ? "--" : scope.row.status }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                          {{ scope.row.status === "" ? "--" : scope.row.status }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="remark" label="备注">
                        <template slot-scope="scope">
                          {{ scope.row.remark === "" ? "--" : scope.row.remark }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="createAt" label="创建时间">
                        <template slot-scope="scope">
                          {{ scope.row.createAt === "" ? "--" : scope.row.createAt }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="updateAt" label="修改时间">
                        <template slot-scope="scope">
                          {{ scope.row.updateAt === "" ? "--" : scope.row.updateAt }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                  <el-tab-pane label="分类账薄" name="ninth">
                    <el-table :data="LedgerTableData" :row-style="{ height: '35px' }" :cell-style="{ padding: '0' }"
                      :height="tableHeight - 86">
                      <el-table-column prop="id" label="编号" width="240">
                        <template slot-scope="scope">
                          {{ scope.row.id === "" ? "--" : scope.row.id }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="currency" label="币种">
                        <template slot-scope="scope">
                          {{ scope.row.currency === "" ? "--" : scope.row.currency }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="amount" label="金额">
                        <template slot-scope="scope">
                          {{ scope.row.amount === "" ? "--" : scope.row.amount }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="fee" label="手续费">
                        <template slot-scope="scope">
                          {{ scope.row.fee === "" ? "--" : scope.row.fee }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="accType" label="母账户类型">
                        <template slot-scope="scope">
                          {{ scope.row.accType === "" ? "--" : scope.row.accType }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="bizType" label="业务类型">
                        <template slot-scope="scope">
                          {{ scope.row.bizType === "" ? "--" : "" }}
                          <span v-if="scope.row.bizType == 'Deposit'">充值</span>
                          <span v-if="scope.row.bizType == 'Withdraw'">提现</span>
                          <span v-if="scope.row.bizType == 'Transfer'">转账</span>
                          <span v-if="scope.row.bizType == 'Exchange'">交易</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="direct" label="出入账方向">
                        <template slot-scope="scope">
                          {{ scope.row.direct === "" ? "--" : scope.row.direct }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="createAt" label="创建时间">
                        <template slot-scope="scope">
                          {{ scope.row.createAt === "" ? "--" : scope.row.createAt }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="updateAt" label="修改时间">
                        <template slot-scope="scope">
                          {{ scope.row.updateAt === "" ? "--" : scope.row.updateAt }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                  <el-pagination layout="prev, pager, next " @current-change="handlePageChange"
                    :page-size="pageConfig.pageSize" :total="pageConfig.totalNum"
                    :current-page="pageConfig.currentPage">
                  </el-pagination>
                </el-tabs>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
          <el-tab-pane label="持仓" name="ten">
            <el-table ref="holdsTableData" :data="holdsTableData" :row-style="{ height: '35px' }"
              :cell-style="{ padding: '0' }" :height="tableHeight" @filter-change="filterChange">
              <el-table-column prop="orderId" label="交易品种" width="210">
                <template slot-scope="scope">
                  {{ scope.row.symbol === "" ? "--" : scope.row.symbol }}
                </template>
              </el-table-column>
              <el-table-column prop="leverage" label="杠杆倍数" width="80">
                <template slot-scope="scope">
                  {{ scope.row.leverage === "" ? "--" :
                    scope.row.leverage }}
                </template>
              </el-table-column>
              <el-table-column prop="holdId" label="持仓ID" width="80">
                <template slot-scope="scope">
                  {{ scope.row.holdId === "" ? "--" : scope.row.holdId }}
                </template>
              </el-table-column>
              <el-table-column prop="holdPrice" label="持仓均价" width="180">
                <template slot-scope="scope">
                  {{ scope.row.holdPrice === "" ? "--" : scope.row.holdPrice }}
                </template>
              </el-table-column>
              <el-table-column prop="holdSz" label="持仓量" width="180">
                <template slot-scope="scope">
                  {{ scope.row.holdSz === "" ? "--" : scope.row.holdSz }}
                </template>
              </el-table-column>
              <el-table-column prop="openBal" label="开仓保证金" width="200">
                <template slot-scope="scope">
                  {{ scope.row.openBal === "" ? "--" : scope.row.openBal }}
                </template>
              </el-table-column>
              <!-- <el-table-column prop="holdBal" label="持仓保证金" width="200">
                <template slot-scope="scope">
                  {{ scope.row.holdBal === "" ? "--" : scope.row.holdBal }}
                </template>
              </el-table-column> -->
              <el-table-column prop="holdSide" label="持仓方向" width="120"
                :filters="[{ text: '买', value: 'buy' }, { text: '卖', value: 'sell' },]" column-key="side">
                <template slot-scope="scope">
                  <span v-if="scope.row.holdSide == 'buy'" style="color: green">买</span>
                  <span v-if="scope.row.holdSide == 'sell'" style="color: red">卖</span>
                </template>
              </el-table-column>
              <el-table-column prop="ccy" label="保证金币种" width="120">
                <template slot-scope="scope">
                  {{ scope.row.ccy === "" ? "--" : scope.row.ccy }}
                </template>
              </el-table-column>
              <el-table-column prop="mgnMode" label="保证金模式" width="">
                <template slot-scope="scope">
                  {{ scope.row.mgnMode === "" ? "--" : "" }}
                  <span v-if="scope.row.mgnMode == 'cross'">全仓</span>
                  <span v-if="scope.row.mgnMode == 'isolated'">逐仓</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- <el-pagination layout="prev, pager, next " @current-change="handleFillsPageChange"
              :page-size="pageConfig.pageSize" :total="pageConfig.ftotalNum" :current-page="pageConfig.fcurrentPage">
            </el-pagination>
            <el-button size="mini" @click="getFirstPage()">首页</el-button>
            <el-button size="mini" @click="getLastPage()">上一页</el-button>
            <el-button size="mini" @click="getNextPage()">下一页</el-button> -->
          </el-tab-pane>
        </el-tabs>
        <!-- tabs end -->
        <!-- 撤单按钮 -->
        <div class="tabright1">
          <div v-if="isCancelBtn">
            <el-button type="warning" size="mini" @click="cancelClick">撤单</el-button>
            <el-button type="danger" size="mini" @click="cancelAllClick">全部撤单</el-button>
          </div>
        </div>
        <!-- 查询按钮 -->
        <div>
          <div v-if="isQry" class="tabright2">
            <el-date-picker v-model="dateValue" size="mini" type="date" value-format="timestamp" placeholder="请选择日期"
              style="width: 160px">
            </el-date-picker>
          </div>
          <div v-if="isQry2" class="tabright3">
            <el-select size="mini" v-model="bizType" placeholder="请选择分类" style="width: 140px">
              <el-option label="充值" value="DEPOSIT"></el-option>
              <el-option label="提现" value="WITHDRAW"></el-option>
              <el-option label="转账" value="TRANSFER"></el-option>
              <el-option label="子账户转账" value="SUB_TRANSFER"></el-option>
              <!-- <el-option label="交易" value="TRADE_EXCHANGE"></el-option>
              <el-option label="杠杆交易" value="MARGIN_EXCHANGE"></el-option>
              <el-option label="鼓励金" value="KUCOIN_BONUS"></el-option> -->
            </el-select>
          </div>
          <div v-if="isQry" class="tabright4">
            <el-button type="warning" size="mini" @click="getDepOrWithList('1')">&nbsp;查询&nbsp;</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "./api";
import exSymbols from "@/proto/exSymbols_pb";
import exLevel2 from "@/proto/exLevel2_pb";
import exAccounts from "@/proto/exAccounts_pb";
import exQryOrders from "@/proto/exQryOrders_pb";
import exQryFills from "@/proto/exQryFills_pb";
import exQryHolds from "@/proto/exQryHolds_pb";
// import exQryLimitFills from '@/proto/exQryLimitFills_pb'
import dbPermission from "@/proto/dbPermission_pb";
import exDeposit from "@/proto/exDeposit_pb";
import exLedger from "@/proto/ExLedger_pb";
// import exInsertOrder from '@/proto/exInsertOrder_pb'
// import exDeleteOrder from '@/proto/exDeleteOrder_pb'
import utils from "../lib/utils";
import Decimal from 'decimal.js';
let mathjs = require("mathjs");
// import exOrderInfo from '@/proto/exOrderInfo_pb'
// let Base64 = require('js-base64').Base64
export default {
  name: "Trade",
  data() {
    return {
      websocket: null,
      defaultExpandedKeys: [],
      symbolsData: [],
      pageConfig: {
        currentPage: 1,
        totalNum: 0,
        ftotalNum: 0,
        totalPage: 0,
        pageSize: 10
      },
      selectedSymbolObj: {
        token: "",
        exchange: 1,
        exchangeName: "",
        symbol: "",
        apiId: "", // 当前apiId
        apiAlias: "", // 当前api 别名
        baseCurrency: "", // 当前商品货币
        quoteCurrency: "", // 当前计价货币
        baseCurrencyAvailable: "0", // 当前可用余额
        quoteCurrencyAvailable: "0" // 当前可用余额
      },
      baseTabelLabel: "数量",
      quoteTabelLabel: "价格",
      totalTabelLabel: "累计数量",
      totalAmountTabelLabel: "累计金额",
      currencySymbol: {
        symbol: "BTCUSDT",
        baseCurrency: "BTC",
        quoteCurrency: "USDT",
        baseIncrease: 1,
        basePrecision: 2, //精度
        quoteIncrease: 1,
        quotePrecision: 2,
        priceIncrease: 0.1, //价格步长
        pricePrecision: 2, //价格精度
        amountIncrease: 0, //金额步长
        amountPrecision: 0, //金额精度
        pricePrecisionArr: [0.001, 0.01, 0.1] //精度聚合数组
      },
      buyPriceDisable: false,
      buyNumDisable: false,
      buyAmountDisable: false,
      buyPrice: 0,
      buyPriceType: 2,
      buyNumType: "",
      buyNum: 0,
      buyAmount: 0,
      buyHiddenChecked: false,
      buyIcebergChecked: false,
      buyIcebergCheckedDisabled: false,
      buyIcebergNum: 0,
      buyIcebergNumDisabled: true,
      buySuperPriceNum: 0, //买超价点位
      buySuperPriceNumDisabled: true, //买超价可用标识
      sellSuperPriceNum: 0, //卖超价点位
      sellSuperPriceNumDisabled: true, //卖超价可用标识
      sellPriceDisable: false,
      sellAmountDisable: false,
      sellPrice: 0,
      sellPriceType: 2,
      sellNum: 0,
      sellNumType: "",
      sellAmount: 0,
      sellHiddenChecked: false,
      sellIcebergChecked: false,
      sellIcebergCheckedDisabled: false,
      sellIcebergNum: 0,
      sellIcebergNumDisabled: true,
      buyTypeRadio: "GTC",
      buyPostOnly: false,
      buyPostOnlyDisabled: false,
      sellTypeRadio: "GTC",
      sellPostOnly: false,
      sellPostOnlyDisabled: false,
      buyReduceOnly: false,
      sellReduceOnly: false,
      confirmChecked: false,
      activetabName: "first",
      accounttabName: "fourth",
      rechargetabName: "seventh",
      radio: 3,
      isCancelBtn: false,
      isQry: false,
      isQry2: false,
      dateValue: null,
      msg: "Welcome to tradeeeeeeeeeeeeeeeeeee",
      defaultProps: {
        children: "children",
        label: "label"
      },
      menuData: [],
      getDeepDataInterval: Function,
      bidTableData: [],
      askTableData: [],
      accountTableData: [],
      transferTableData: [],
      orderTableData: [], //委托表格数据
      fillsTableData: [], //成交表格数据
      holdsTableData: [], //持仓表格数据
      tableData: [], //表格全部数据
      depositTableData: [],
      withdrawTableData: [],
      LedgerTableData: [],
      fillsAllData: [],
      selectedOrderId: "", // 选中的未成交订单号
      selectedRow: "",
      startDate: "",
      endDate: "",
      loading: "",
      buyfollow: false,
      buydis: false, //买跟随
      sellfollow: false,
      selldis: false,
      side: "",
      bizType: "TRANSFER", //业务类型
      tableHeight: null,
      selectedPricePrecision: "0.1", // 选中的价格精度
      selectedTotal: 0,
      layoutMoudle: 0, // 布局模式 0：居中布局  1：显示全卖  2：显示全买
      showTotal: true, // true:深度行情累计数量
      showAmountTotal: false, // true:深度行情累计金额
      activeTradeTab: "order",
      activeTradeTabTwo: "order",

      splitForm: {
        startPrice: 0,
        endPrice: 0,
        amount: 0,
        orderCount: 5
      },
      countFloat: 0,
      splitOrders: [],
      splitSummary: {
        avgPrice: 0,
        totalCost: 0
      },
      timeoutNum: 0
    };
  },
  /**
   * computed用来监控自己定义的变量，该变量不在data里面声明，
   * 直接在computed里面定义，
   * 然后就可以在页面上进行双向数据绑定展示出结果或者用作其他处理；
   */
  computed: {
    buyNumValue: {
      get() {
        // console.log("buyNumValue get", this.buyNum);
        return this.buyNum;
      },
      set(val) {
        this.buyNum = val;
        // this.$emit('input', val); // 双向绑定
      }
    },
    key() {
      return this.$route.path + new Date().getTime();
    },
    getWsMsg() {
      return this.$store.state.level2msg;
    },
    myPrecision() {
      // console.log("currencySymbol.basePrecision", this.currencySymbol.basePrecision);
      // console.log("currencySymbol.baseIncrease", this.currencySymbol.baseIncrease);
      return this.currencySymbol.basePrecision >= 0 ? this.currencySymbol.basePrecision : 0
    },
  },
  /**
   * watch主要用于监控vue实例的变化，它监控的变量当然必须在data里面声明才可以，
   * 它可以监控一个变量，也可以是一个对象，
   */
  watch: {
    getWsMsg: function (newVal) {
      this.resolveLevel2Buffer(newVal);
    },
    buyNum: {
      handler(newVal) {
        if (newVal !== undefined && newVal !== null) {
          const rounded = this.applyRounding(newVal);
          if (rounded !== newVal) {
            this.buyNum = rounded;
          }
        }
      }
    }
  },
  methods: {
    /**
     * 累计数量、累计金额选择
     */
    handleTotal(command) {
      if (command === "0") {
        this.selectedTotal = 0;
        this.showTotal = true;
        this.showAmountTotal = false;
      } else if (command === "1") {
        this.selectedTotal = 1;
        this.showTotal = false;
        this.showAmountTotal = true;
      }
    },
    /**
     * 布局模式选择
     */
    choseLayoutModel(status) {
      this.layoutMoudle = status;
      //this.$refs.askTableRef1.bodyWrapper.scrollTop = this.$refs.askTableRef1.bodyWrapper.scrollHeight;
    },
    /**
     * 深度行情价格精度选择
     */
    handlePricePrecision(command) {
      // console.log(command);
      // this.$message('click on item ' + command);
      if (command === "0") {
        this.selectedPricePrecision = this.currencySymbol.pricePrecisionArr[0];
      } else if (command === "1") {
        this.selectedPricePrecision = this.currencySymbol.pricePrecisionArr[1];
      } else if (command === "2") {
        this.selectedPricePrecision = this.currencySymbol.pricePrecisionArr[2];
      }
    },
    /**
     * 深度行情table点击事件
     * @param {*} val
     */
    askTableHandleCurrentChange(val) {
      // console.log("val=", JSON.stringify(val));
      if (val == null) return;
      this.buyPriceType = "";
      this.buyfollow = false;
      // 买入跟随禁用
      this.buydis = true;
      this.buyPrice = val.price;

      this.sellPriceType = "";
      this.sellfollow = false;
      // 卖出跟随禁用
      this.selldis = true;
      this.sellPrice = val.price;

      // 分单价格输入框
      this.splitForm.startPrice = Number.parseFloat(val.price);
      this.splitForm.endPrice = Number.parseFloat(val.price);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.side === "buy") {
        return "buy-row";
      } else if (row.side === "sell") {
        return "sell-row";
      }
      return "";
    },
    // 买入价格输入框失去焦点
    onBuyPriceInputChange() {
      // 计算金额
      // this.buyAmount = mathjs.multiply(mathjs.bignumber(this.buyPrice), mathjs.bignumber(this.buyNum))
      // 计算数量
      if (this.buyAmount !== 0) {
        this.buyNum = mathjs.divide(
          mathjs.bignumber(this.buyAmount),
          mathjs.bignumber(this.buyPrice)
        );
      }
    },
    // 买入数量输入框失去焦点


    // 买入数量输入框失去焦点
    onBuyNumInputChange(newVal, oldVal) {
      // 计算金额
      this.buyAmount = mathjs.multiply(
        mathjs.bignumber(this.buyPrice),
        mathjs.bignumber(this.buyNum)
      );
    },
    applyRounding(num) {
      if (isNaN(num)) return 0;
      const prec = this.currencySymbol.basePrecision;
      if (prec >= 0) {
        // 正数或0：原生小数精度
        return parseFloat(num.toFixed(prec));
      } else {
        // 负数：舍入到 10^|prec| 的倍数（整数模式）
        const multiplier = Math.pow(10, Math.abs(prec));
        return Math.round(num / multiplier) * multiplier;
      }
    },

    myPrecision() {
      // console.log("currencySymbol.basePrecision", this.currencySymbol.basePrecision);
      // console.log("currencySymbol.baseIncrease", this.currencySymbol.baseIncrease);
      return this.currencySymbol.basePrecision >= 0 ? this.currencySymbol.basePrecision : 0
    },
    // 买入金额输入框失去焦点
    onBuyAmountInputChange() {
      if (this.buyPrice !== 0) {
        // 计算数量
        this.buyNum = mathjs.divide(
          mathjs.bignumber(this.buyAmount),
          mathjs.bignumber(this.buyPrice)
        );
      }
    },
    // 买入价格输入框失去焦点
    onSellPriceInputChange() {
      // 计算金额
      // this.sellAmount = mathjs.multiply(mathjs.bignumber(this.sellPrice), mathjs.bignumber(this.sellNum))
      // 计算数量
      if (this.sellAmount !== 0) {
        this.sellNum = mathjs.divide(
          mathjs.bignumber(this.sellAmount),
          mathjs.bignumber(this.sellPrice)
        );
      }
    },
    // 卖出数量输入框失去焦点
    onSellNumInputChange() {
      // 计算金额
      this.sellAmount = mathjs.multiply(
        mathjs.bignumber(this.sellPrice),
        mathjs.bignumber(this.sellNum)
      );
    },
    // 卖出价格输入框 change
    onSellAmountInputChange() {
      if (this.sellPrice !== 0) {
        // 计算数量
        this.sellNum = mathjs.divide(
          mathjs.bignumber(this.sellAmount),
          mathjs.bignumber(this.sellPrice)
        );
      }
    },
    onBuyPriceInputFocus() {
      this.buyPriceType = "";
      this.buyfollow = false;
      // 买入跟随禁用
      this.buydis = true;
    },
    onSellPriceInputFocus() {
      this.sellPriceType = "";
      this.sellfollow = false;
      // 卖出跟随禁用
      this.selldis = true;
    },
    sellIcebergChange(val) {
      if (val) {
        this.sellIcebergNumDisabled = false;
      } else {
        this.sellIcebergNumDisabled = true;
        this.sellIcebergNum = 0;
      }
    },
    icebergChange(val) {
      if (val) {
        this.buyIcebergNumDisabled = false;
      } else {
        this.buyIcebergNumDisabled = true;
        this.buyIcebergNum = 0;
      }
    },
    confirmChange(val) {
      localStorage.setItem("confirmval", val);
    },
    buyHiddenChange(val) {
      if (val) {
        this.buyIcebergChecked = false;
        this.buyIcebergCheckedDisabled = true;
        this.buyIcebergNum = 0;
        this.buyIcebergNumDisabled = true;
      } else {
        this.buyIcebergCheckedDisabled = false;
      }
    },
    sellHiddenChange(val) {
      if (val) {
        this.sellIcebergChecked = false;
        this.sellIcebergCheckedDisabled = true;
        this.sellIcebergNum = 0;
        this.sellIcebergNumDisabled = true;
      } else {
        this.sellIcebergCheckedDisabled = false;
      }
    },
    sellTypeRadioChange(val) {
      if (val === "IOC" || val === "FOK") {
        this.sellPostOnlyDisabled = true;
      } else {
        this.sellPostOnlyDisabled = false;
      }
    },
    buyTypeRadioChange(val) {
      if (val === "IOC" || val === "FOK") {
        this.buyPostOnlyDisabled = true;
      } else {
        this.buyPostOnlyDisabled = false;
      }
    },
    // 首页
    getFirstPage() {
      let page = 1;
      if (this.activetabName === "first") {
        this.getOrders("active", page);
      } else if (this.activetabName === "second") {
        this.getFills(page);
      }
    },

    // 上一页
    getLastPage() {
      var that = this;
      let page;
      // 第一页
      if (that.pageConfig.currentPage === 1) {
        page = -2;
        return;
      } else {
        page = -(that.pageConfig.currentPage -= 1);
      }
      let exchange = that.selectedSymbolObj.exchange;
      if (exchange === 3 || exchange === 6 || exchange === 8 || exchange === 10 || exchange === 11 || exchange === 12 || exchange === 15 || exchange === 16 || exchange === 20) {
        if (that.pageConfig.currentPage === 1) {
          page = 1;
        } else {
          page = (that.pageConfig.currentPage -= 1);
        }
        let pageSize = 10;
        let start = (page - 1) * pageSize;
        let end = page * pageSize;
        if (that.activetabName === "first") {
          if (that.pageConfig.totalNum > pageSize) {
            that.orderTableData = that.tableData.slice(start, end);
          } else {
            that.orderTableData = that.tableData;
          }
        } else if (that.activetabName === "second") {
          if (that.pageConfig.totalNum > pageSize) {
            that.fillsTableData = that.tableData.slice(start, end);
          } else {
            that.fillsTableData = that.tableData;
          }
        }
      } else {
        if (that.activetabName === "first") {
          that.getOrders("active", page);
        } else if (that.activetabName === "second") {
          that.getFills(page);
        }
      }
    },

    // 下一页
    getNextPage() {
      // 委托当前页改变
      var that = this;
      let page = that.pageConfig.currentPage += 1;
      let pageSize = 10;
      let start = (page - 1) * pageSize;
      let end = page * pageSize;
      let exchange = that.selectedSymbolObj.exchange;
      if (exchange === 3 || exchange === 6 || exchange === 8 || exchange === 10 || exchange === 11 || exchange === 12 || exchange === 15 || exchange === 16 || exchange === 20) {
        if (that.activetabName === "first") {
          if (that.pageConfig.totalNum > pageSize) {
            that.orderTableData = that.tableData.slice(start, end);
          } else {
            that.orderTableData = that.tableData;
          }
        } else if (that.activetabName === "second") {
          if (that.pageConfig.totalNum > pageSize) {
            that.fillsTableData = that.tableData.slice(start, end);
          } else {
            that.fillsTableData = that.tableData;
          }
        }
      } else {
        if (that.activetabName === "first") {
          that.getOrders("active", page);
        } else if (that.activetabName === "second") {
          that.getFills(page);
        }
      }
    },

    // 分类账薄分页
    handlePageChange() {
      var page = (this.pageConfig.currentPage += 1);
      var tab = this.rechargetabName;
      if (tab.name === "seventh") {
        // 充值记录
        this.getDeposit(page.toString());
      } else if (tab.name === "eighth") {
        // 提现记录
        this.getWithdrawal(page.toString());
      } else if (this.rechargetabName === "ninth") {
        this.getLedger(page.toString());
      }
    },

    // 币对点击事件
    handleNodeClick(data, node, comp) {
      if (node.isLeaf) {
        // this.$message(node.data.label)
        this.bidTableData = [];
        this.askTableData = [];
        this.accountTableData = [];
        this.orderTableData = [];
        this.fillsTableData = [];
        this.holdsTableData = [];
        this.selectedSymbolObj = {};
        this.buyPrice = "";
        this.buyPriceType = 2;
        this.sellPrice = "";
        this.sellPriceType = 2;
        // 清空筛选条件
        this.side = "";
        this.$refs.orderTableData.clearFilter();
        this.$refs.fillsTableData.clearFilter();
        // 初始化当前api 及 币对
        this.initSymbolObj(node.data);
        this.initNodeData();
      }
    },

    async initNodeData() {
      // 获取所有交易币对信息/初始化当前币对信息
      await this.getSymbol();
      // 查询账户资金
      this.getAccounts();
      // 查询未成交订单
      this.getOrders("active", "1");
      // 获取深度行情
      // this.getLevel2()
      this.stopLevel2();
      this.startLevel2();
      this.activetabName = "first";
      if (this.activetabName === "first") {
        this.isCancelBtn = true; // 撤单按钮
        this.isQry = false; // 查询按钮
        this.isQry2 = false;
      }
    },

    exchangeHandleClick(val) {
      // this.exchange = val
    },

    handleChange() { },

    // 委托表格选中事件
    handleCurrentChange(val) {
      if (val === null) {
        this.selectedOrderId = "";
        return;
      }
      this.selectedRow = val;
      this.selectedOrderId = val.id;
    },

    // 委托tab
    tabHandleClick(tab, event) {
      this.activetabName = tab.name;
      // 清空筛选条件
      this.side = "";
      this.$refs.orderTableData.clearFilter();
      this.$refs.fillsTableData.clearFilter();
      this.isCancelBtn = false;
      this.isQry = false;
      this.isQry2 = false;
      if (tab.name === "first") { //委托
        this.isCancelBtn = true;
        this.getOrders("active", "1");
      } else if (tab.name === "second") { //成就
        this.getFills("1");
      } else if (tab.name === "third") { //资产
        this.accounttabName = "fourth"; // 默认资产余额
        // 查询账户资金信息
        this.getAccounts();
      } else if (tab.name === "ten") { //持仓
        this.getHolds();
      }
    },

    // 资产tab
    accounttabClick(tab) {
      this.isQry = false;
      this.isQry2 = false;
      if (tab.name === "fourth") {
        this.getAccounts();
      } else if (tab.name === "fifth") {
        this.getAccounts();
      } else if (tab.name === "sixth") {
        this.isQry = true;
        this.rechargetabName = "seventh"; // 默认充值记录
        this.dateValue = null; // 清空时间
        this.getDeposit("1");
      }
    },

    // 账薄tab
    rechargetabClick(tab) {
      this.dateValue = null; // 清空时间
      this.isQry2 = false;
      if (tab.name === "seventh") {
        // 充值记录
        this.getDeposit("1");
      } else if (tab.name === "eighth") {
        // 提现记录
        this.getWithdrawal("1");
      } else if (this.rechargetabName === "ninth") {
        this.isQry2 = true;
        this.getLedger("1");
      }
    },

    cellStyle(row, column, rowIndex, columnIndex) {
      // 根据报警级别显示颜色
      if (row.column.label === "Price(USDT)") {
        return "color:red;";
      }
    },

    bgred() {
      return "color:red";
    },

    /**
     * 验证买入、卖出价格的合理性
     * 计算买入价格是否偏离盘口价格20%
     * @param {*} price
     * @param {*} direction
     */
    checkPriceValid(direction) {
      if (direction === "buy") {
        if (this.bidTableData.length > 0) {
          // 取买入价格
          let price = utils.toNonExponential(this.buyPrice);
          let lastPrice = this.bidTableData[0].price;
          if (((price - lastPrice) / lastPrice) > 0.2) {
            // 价格高出第一档20%
            return true;
          }
        } else {
          return true;
        }
      } else if (direction === "sell") {
        if (this.askTableData.length > 0) {
          // 取卖出价格
          let price = utils.toNonExponential(this.sellPrice);
          let lastPrice = this.askTableData[this.askTableData.length - 1].price;
          // 价格低于第一档20%
          if ((((lastPrice - price) / lastPrice)) > 0.2) {
            return true;
          }
        } else {
          return true;
        }
      }
      return false;
    },

    /**
     * 买入按钮click
     */
    buyClick() {
      if (this.buyPriceType === 4) {
        //超价买入
        if (this.buySuperPriceNum === 0) {
          this.$message("请输入买入超价点位");
          return;
        }
        //价格=市价+超价点位
        // 买入价格取对手最新价
        let price = this.askTableData[this.askTableData.length - 1].price;
        this.buyPrice = mathjs.add(Number(price), Number(this.buySuperPriceNum));
      }

      //计算买入价格是否偏离盘口价格20%，如果是，弹出确认框
      if (this.checkPriceValid("buy")) {
        this.$confirm("确认买入？(买入价偏离盘口20%)", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.insertOrderBuy();
        }).catch(() => { });
      } else {
        this.insertOrderBuy();
      }
    },

    /**
     * 卖出按钮click
     */
    sellClick() {
      if (this.sellPriceType === 4) {
        //超价买入
        if (this.sellSuperPriceNum === 0) {
          this.$message("请输入卖出超价点位");
          return;
        }
        //超价卖出  价格=市价-超价点位
        //卖出价格取对手最新价
        let price = this.bidTableData[0].price;
        this.sellPrice = mathjs.subtract(Number(price), Number(this.sellSuperPriceNum));
        // console.log("this.sellsPrice==", this.sellPrice);
      }
      //计算卖出价格是否偏离盘口价格20%，如果是，弹出确认框
      if (this.checkPriceValid("sell")) {
        this.$confirm("确认卖出？(卖出价偏离盘口20%)", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.insertOrderSell();
        }).catch(() => { });
      } else {
        this.insertOrderSell();
      }
    },

    /**
     * 撤单
     */
    cancelClick() {
      this.deleteOrderByOrderId();
    },

    /**
     * 全部撤单
     */
    cancelAllClick() {
      this.$confirm("是否全部撤单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteOrderBySymbol();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消全部撤单"
          });
        });
    },

    // 记录查询
    getDepOrWithList() {
      if (this.rechargetabName === "seventh") {
        this.getDeposit("1");
      } else if (this.rechargetabName === "eighth") {
        this.getWithdrawal("1");
      } else if (this.rechargetabName === "ninth") {
        this.getLedger("1");
      }
    },

    // 充值记录
    getDeposit(currentPage) {
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        status: "",
        startAt: this.dateValue,
        endAt: this.dateValue === null ? null : this.dateValue + 86400000,
        currency: "",
        currentPage: currentPage,
        pageSize: this.pageConfig.pageSize + ""
      };
      API.DepositList(data).then((res) => {
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exDeposit.ExDeposit.deserializeBinary(buffer);
          var depositData = message.getData();
          if (depositData) {
            this.pageConfig.totalNum = depositData.getTotalnum();
            this.pageConfig.totalPage = depositData.getTotalpage();
            this.pageConfig.currentPage = depositData.getCurrentpage();
          }
          var depositTableArray = [];
          depositData.getItemsList().forEach((element) => {
            // console.log('element=', element)
            var depositInfo = {
              // id: element.getId(),
              // intId: element.getIntid(),
              currency: element.getCurrency(),
              amount: element.getAmount(),
              fee: element.getFee(),
              status: element.getStatus(),
              remark: element.getRemark(),
              createAt:
                element.getCreateat() === 0
                  ? ""
                  : utils.dateFormat(element.getCreateat()),
              updateAt:
                element.getUpdateat() === 0
                  ? ""
                  : utils.dateFormat(element.getUpdateat())
            };
            depositTableArray.push(depositInfo);
          });
          this.depositTableData = [];
          this.depositTableData = depositTableArray;
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
        }
      });
    },

    // 提币记录
    getWithdrawal(currentPage) {
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        status: "",
        startAt: this.dateValue,
        endAt: this.dateValue === null ? null : this.dateValue + 86400000,
        currency: "",
        currentPage: currentPage,
        pageSize: this.pageConfig.pageSize + ""
      };
      API.WithdrawList(data).then((res) => {
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exDeposit.ExDeposit.deserializeBinary(buffer);
          var withdrawData = message.getData();
          if (withdrawData) {
            this.pageConfig.totalNum = withdrawData.getTotalnum();
            this.pageConfig.totalPage = withdrawData.getTotalpage();
            this.pageConfig.currentPage = withdrawData.getCurrentpage();
          }
          var withdrawArray = [];
          withdrawData.getItemsList().forEach((element) => {
            // console.log('element=', element)
            var withdrawInfo = {
              // id: element.getId(),
              // intId: element.getIntid(),
              currency: element.getCurrency(),
              amount: element.getAmount(),
              fee: element.getFee(),
              status: element.getStatus(),
              remark: element.getRemark(),
              createAt:
                element.getCreateat() === 0
                  ? ""
                  : utils.dateFormat(element.getCreateat()),
              updateAt:
                element.getUpdateat() === 0
                  ? ""
                  : utils.dateFormat(element.getUpdateat())
            };
            withdrawArray.push(withdrawInfo);
          });
          this.withdrawTableData = [];
          this.withdrawTableData = withdrawArray;
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
        }
      });
    },

    // 分类账薄
    getLedger(currentPage) {
      this.LedgerTableData = [];
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        status: "",
        startAt: this.dateValue,
        endAt: this.dateValue === null ? null : this.dateValue + 86400000,
        currency: "",
        bizType: this.bizType,
        currentPage: currentPage,
        pageSize: this.pageConfig.pageSize + ""
      };
      API.LedgerList(data).then((res) => {
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exLedger.ExLedger.deserializeBinary(buffer);
          var LedgerData = message.getData();
          if (LedgerData) {
            this.pageConfig.totalNum = LedgerData.getTotalnum();
            this.pageConfig.totalPage = LedgerData.getTotalpage();
            this.pageConfig.currentPage = LedgerData.getCurrentpage();
          }
          var LedgerArray = [];
          LedgerData.getItemsList().forEach((element) => {
            // console.log('element=', element);
            var LedgerInfo = {
              id: element.getId(),
              // intId: element.getIntid(),
              currency: element.getCurrency(),
              amount: element.getAmount(),
              fee: element.getFee(),
              accType: element.getAcctype(),
              bizType: element.getBiztype(),
              direct: element.getDirect(),
              createAt:
                element.getCreateat() === 0
                  ? ""
                  : utils.dateFormat(element.getCreateat()),
              updateAt:
                element.getUpdateat() === 0
                  ? ""
                  : utils.dateFormat(element.getUpdateat())
            };
            LedgerArray.push(LedgerInfo);
          });
          this.LedgerTableData = LedgerArray;
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
        }
      });
    },

    // 价格类型单选框(买入)
    buyPriceTypeChange() {
      if (this.buyPriceType === 1) {
        // 市价
        // 价格 金额输入框禁用
        this.buyPriceDisable = true;
        this.buyAmountDisable = false;
        this.buyNumDisable = true;
        this.buydis = false;
        // 超价点位禁用
        this.buySuperPriceNumDisabled = true;
        if (this.askTableData.length > 0) {
          this.buyPrice = this.askTableData[this.askTableData.length - 1].price;
        }
      } else if (this.buyPriceType === 2) {
        // 对手价
        // 价格 金额输入框禁用
        this.buyPriceDisable = false;
        this.buyNumDisable = false;
        this.buydis = false;
        // 超价点位禁用
        this.buySuperPriceNumDisabled = true;
        if (this.askTableData.length > 0) {
          this.buyPrice = this.askTableData[this.askTableData.length - 1].price;
        }
      } else if (this.buyPriceType === 3) {
        // 挂单价
        // 价格 金额输入框禁用
        this.buyPriceDisable = false;
        this.buyNumDisable = false;
        this.buydis = false;
        // 超价点位禁用
        this.buySuperPriceNumDisabled = true;
        if (this.bidTableData.length > 0) {
          this.buyPrice = this.bidTableData[0].price;
        }
      } else if (this.buyPriceType === 4) {
        // 超价
        // 价格 金额输入框禁用
        this.buyPriceDisable = true;
        this.buyNumDisable = false;
        this.buydis = false;
        this.buySuperPriceNumDisabled = false;
        // 买入价格
        if (this.askTableData.length > 0) {
          this.buyPrice = this.askTableData[this.askTableData.length - 1].price;
        }
      }
    },

    buyNumTypeChange(val) {
      // console.log('this.selectedSymbolObj.baseCurrency ===', this.selectedSymbolObj.baseCurrency);
      // console.log('this.selectedSymbolObj.quoteCurrency ===', this.selectedSymbolObj.quoteCurrency);
      if (
        this.selectedSymbolObj.baseCurrency === "" ||
        this.selectedSymbolObj.quoteCurrency === ""
      ) {
        return;
      }
      let balance = 0;
      let buyPrice = 0;
      if (this.buyPrice === 0) {
        buyPrice = this.askTableData[this.askTableData.length - 1].price;
      } else {
        buyPrice = this.buyPrice;
      }

      let num = 0;
      // 获取账户可用资金
      for (let element of this.accountTableData) {
        if (
          element.currency === this.selectedSymbolObj.quoteCurrency &&
          (element.type === "trade" || element.type === "")
        ) {
          // 交易账户
          balance = element.available;
          break;
        }
      }
      let purshaseAmount = 0;
      if (balance === 0 || buyPrice === 0) {
        return;
      }
      if (val === 1) {
        // 10%
        purshaseAmount = balance * 0.1;
        num = (balance * 0.1) / buyPrice;
        // num = mathjs.chain(mathjs.bignumber(balance)).multiply(mathjs.bignumber(0.1)).divide(mathjs.bignumber(buyPrice))
      } else if (val === 2) {
        purshaseAmount = balance * 0.25;
        num = (balance * 0.25) / buyPrice;
      } else if (val === 3) {
        purshaseAmount = balance * 0.3;
        num = (balance * 0.3) / buyPrice;
      } else if (val === 4) {
        purshaseAmount = balance * 0.5;
        num = (balance * 0.5) / buyPrice;
      } else if (val === 5) {
        purshaseAmount = balance;
        num = balance / buyPrice;
      }
      // console.log("num的数值是", num);
      num = utils.formatDecimal(num, this.currencySymbol.basePrecision);

      this.buyNum = num;
      this.buyAmount = purshaseAmount;
      // console.log('this.buyNum的数值是', this.buyNum);
    },

    sellPriceTypeChange() {
      if (this.sellPriceType === 1) {
        // 市价
        // 价格 金额输入框禁用
        this.sellPriceDisable = true;
        this.sellNumDisable = true;
        this.selldis = false;
        // 超价点位禁用
        this.sellSuperPriceNumDisabled = true;
        if (this.bidTableData.length > 0) {
          this.sellPrice = this.bidTableData[0].price;
        }
      } else if (this.sellPriceType === 2) {
        // 对手价
        // 价格 金额输入框禁用
        this.sellPriceDisable = false;
        if (this.bidTableData.length > 0) {
          this.sellPrice = this.bidTableData[0].price;
        }
        this.selldis = false;
        // 超价点位禁用
        this.sellSuperPriceNumDisabled = true;
      } else if (this.sellPriceType === 3) {
        // 挂单价
        // 价格 金额输入框禁用
        this.sellPriceDisable = false;
        this.selldis = false;
        // 超价点位禁用
        this.sellSuperPriceNumDisabled = true;
        if (this.askTableData.length > 0) {
          this.sellPrice = this.askTableData[this.askTableData.length - 1].price;
        }
      } else if (this.sellPriceType === 4) {
        // 超价
        // 价格 金额输入框禁用
        this.sellPriceDisable = true;
        this.sellNumDisable = true;
        this.selldis = false;
        // 超价点位
        this.sellSuperPriceNumDisabled = false;
        //卖出价格
        if (this.bidTableData.length > 0) {
          this.sellPrice = this.bidTableData[0].price;
        }
      }
    },

    sellNumTypeChange(val) {
      if (
        this.selectedSymbolObj.baseCurrency === "" ||
        this.selectedSymbolObj.quoteCurrency === ""
      ) {
        return;
      }
      let balance = 0;
      let num = 0;
      // 获取账户可用余额
      for (let element of this.accountTableData) {
        if (
          element.currency === this.selectedSymbolObj.baseCurrency &&
          (element.type === "trade" || element.type === "")
        ) {
          // 交易账户
          balance = element.available;
          break;
        }
      }
      if (balance === 0) {
        return;
      }
      if (val === 1) {
        // 10%
        num = balance * 0.1;
      } else if (val === 2) {
        num = balance * 0.25;
      } else if (val === 3) {
        num = balance * 0.3;
      } else if (val === 4) {
        num = balance * 0.5;
      } else if (val === 5) {
        num = balance;
      }
      num = utils.formatDecimal(num, this.currencySymbol.basePrecision);
      this.sellNum = num;
      this.sellAmount = num * this.sellPrice;
    },
    // 市价(买入)
    onBuyMarketPriceClick() {
      // 价格 金额输入框禁用
      this.buyPriceDisable = true;
      this.buyAmountDisable = true;
    },
    // 对手价(买入)
    onBuyCompetitorsPriceClick() {
      this.buyPriceDisable = false;
      this.buyAmountDisable = false;
    },
    // 挂单价(买入)
    onBuyLimitPriceClick() {
      this.buyPriceDisable = false;
      this.buyAmountDisable = false;
    },
    // 市价(卖出)
    onSellMarketPriceClick() { },
    // 对手价(卖出)
    onSellCompetitorsPriceClick() { },
    // 挂单价(卖出)
    onSellLimitPriceClick() { },
    /**
     * 选择默认菜单、默认币对
     */
    defaultMenu() {
      if (this.menuData.length === 0) {
        return;
      }
      var apiArray = this.menuData[0].children;
      var symbolArray = apiArray[0].children;
      var symbolObj = symbolArray[0];
      this.initSymbolObj(symbolObj);
      this.defaultExpandedKeys.push(symbolObj.id);
      // 设置默认选中节点高亮
      if (this.$refs.menutree) {
        this.$nextTick(function () {
          this.$refs.menutree.setCurrentKey(symbolObj.id);
        });
      }
    },

    /**
     * 初始化当前币对信息
     * @param {*} symbolObj
     */
    initSymbolObj(symbolObj) {
      if (symbolObj.baseCurrency === "" || symbolObj.quoteCurrency === "") {
        console.log("初始化当前币对信息出错");
        return;
      }
      this.selectedSymbolObj.token = symbolObj.token;
      this.selectedSymbolObj.exchange = symbolObj.exchange;
      this.selectedSymbolObj.apiId = symbolObj.apiId;
      this.selectedSymbolObj.apiAlias = symbolObj.alias;
      this.selectedSymbolObj.symbol = symbolObj.symbol;
      // this.selectedSymbolObj.baseCurrency = symbolObj.baseCurrency
      // this.selectedSymbolObj.quoteCurrency = symbolObj.quoteCurrency
      this.selectedSymbolObj.baseCurrencyAvailable = "0";
      this.selectedSymbolObj.quoteCurrencyAvailable = "0";
      // console.log('this.currencySymbol=', this.currencySymbol)
      if (this.exchangeList !== null && this.exchangeList !== undefined) {
        this.exchangeList.forEach((element) => {
          if (this.selectedSymbolObj.exchange === element.id) {
            this.selectedSymbolObj.exchangeName = element.name;
          }
        });
      }

    },

    // 初始化币对数据
    async getMenuData() {
      var data = {
        uid: localStorage.getItem("userName"),
        apiType: '1'
      };
      await API.getMenu(data)
        .then((res) => {
          if (res.data.errcode === 0) {
            var buffer = res.data.buffer;
            var message =
              dbPermission.DbPermissionList.deserializeBinary(buffer);
            var menuArray = [];
            message.getPermissionsList().forEach((element) => {
              // console.log('element=', element)
              // 币种
              var token = element.getToken();
              // var uids = element.getUidsList()
              // var banUids = element.getBanuidsList()
              // var deleted = element.getDeleted()
              var item = {
                id: token,
                label: token
              };
              var apiArray = [];
              element.getApisList().forEach((api) => {
                var apiObj = {
                  id: token + api.getAlias(),
                  baseCurrency: element.getToken(),
                  apiId: api.getId(),
                  label: api.getAlias(),
                  exchange: api.getExchange()
                };
                var symbolArray = [];
                api.getSymbolsList().forEach((symbol) => {
                  var symbolObj = {
                    id: token + "-" + api.getAlias() + "-" + symbol,
                    token: token,
                    label: symbol,
                    symbol: symbol,
                    exchange: api.getExchange(),
                    apiId: api.getId(),
                    alias: api.getAlias()
                  };
                  symbolArray.push(symbolObj);
                });
                apiObj.children = symbolArray;
                apiArray.push(apiObj);
              });
              item.children = apiArray;
              menuArray.push(item);
            });
            this.menuData = menuArray;
          } else {
            this.loading.close();
            this.$message.error(res.data.errcode + ":" + res.data.errmsg);
            if (res.data.errcode === 3005) {
              // 无效的登录凭证
              this.$router.push("/login");
            }
          }
        })
        .catch((err) => {
          console.log("err=", err);
          this.loading.close();
          this.$router.push("/login");
        });
    },

    /**
     * 获取交易所的所有币对数据
     * 初始化币对的精度、步长等信息
     * 初始化当前选择币对的基本信息
     */
    async getSymbol() {
      // console.log('getSymbol---------')
      var data = {
        uid: localStorage.getItem("userName"),
        market: "",
        symbol: this.selectedSymbolObj.symbol,
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange
      };

      await API.getSymbols(data, utils.getCookie("token"))
        .then((res) => {
          if (res.data.errcode === 0) {
            var buffer = res.data.buffer;
            var message = exSymbols.ExSymbols.deserializeBinary(buffer);
            // console.log('getSymbols message=', message)
            var symbolArray = [];
            message.getDataList().forEach((element) => {
              // if (element.getSymbol() === "BTC-USDT-SWAP") {
              //   console.log('getSymbols element==', element.getSymbol())
              //   // console.log('getSymbols element==', element)
              //   // console.log('getSymbols element==', element.getQuotecurrency())
              //   // console.log('getSymbols element==', element.getBasecurrency())
              //   // console.log('getSymbols element==', element.getQuotecurrency())
              //   // console.log('getSymbols element==', element.getBasecurrency())
              //   console.log('getBaseincrement element==', element.getBaseincrement())
              //   console.log('getBaseprecision element==', element.getBaseprecision())
              //   // console.log('getSymbols element==', element)
              //   console.log('getBaseprecision Number==', Number(element.getBaseincrement()));

              // }

              var symbol = {
                symbol: element.getSymbol(),
                baseCurrency: element.getBasecurrency(),
                quoteCurrency: element.getQuotecurrency(),
                baseIncrease: Number(element.getBaseincrement()),
                basePrecision: Number(element.getBaseprecision()), //精度
                quoteIncrease: Number(element.getQuoteincrement()),
                quotePrecision: element.getQuoteprecision(),
                priceIncrease: Number(element.getPriceincrement()), //价格步长
                pricePrecision: Number(element.getPriceprecision()), //价格精度
                amountIncrease: 0, //金额步长
                amountPrecision: 0, //金额精度
                pricePrecisionArr: [] //精度聚合数组
              };
              // if (element.getSymbol() === "AT-USDT-SWAP") {
              //   console.log('getSymbols symbol==', symbol);
              //   console.log('getSymbols calPrecision==', utils.calPrecision(Number(element.getBaseincrement())));
              //   console.log("222=", element.getBaseincrement() !== "" && element.getBaseincrement() !== "undefined");

              // }

              //基础币数量精度、步长
              if (element.getBaseincrement() !== "" && element.getBaseincrement() !== "undefined") {
                // 计算出精度值 5
                symbol.basePrecision = utils.calPrecision(Number(element.getBaseincrement()));
              } else if (element.getBaseprecision() !== "") {
                // 生成步长值 0.0001
                symbol.baseIncrease = utils.createIncreament(Number(element.getBaseprecision()));
              }

              //
              if (element.getQuoteincrement() !== "" && element.getQuoteincrement() !== "undefined") {
                // 计算出精度值 5
                symbol.quotePrecision = utils.calPrecision(Number(element.getQuoteincrement()));
              } else if (element.getQuoteprecision() !== "") {
                // 生成步长值 0.0001
                symbol.quoteIncrease = utils.createIncreament(element.getQuoteprecision());
              }

              // 价格精度、步长
              if (element.getPriceincrement() !== "" && element.getPriceincrement() !== "undefined") {
                // 计算出精度值 5
                symbol.pricePrecision = utils.calPrecision(Number(element.getPriceincrement()));
              } else if (element.getPriceprecision() !== "") {
                // 生成步长值 0.0001
                symbol.priceIncrease = utils.createIncreament(element.getPriceprecision());
              }
              //金额精度=数量精度+价格精度
              symbol.amountPrecision = mathjs.add(Number(symbol.basePrecision), Number(symbol.pricePrecision));
              symbol.amountIncrease = utils.createIncreament(symbol.amountPrecision);
              // 精度选择数组
              let pricePrecisionArr = [];
              pricePrecisionArr.push(new Decimal(symbol.priceIncrease).toFixed(Decimal.maxDigits).toString());
              pricePrecisionArr.push((new Decimal(symbol.priceIncrease).times(new Decimal(10))).toFixed(Decimal.maxDigits).toString());
              pricePrecisionArr.push((new Decimal(symbol.priceIncrease).times(new Decimal(100))).toFixed(Decimal.maxDigits).toString());
              // console.log("pricePrecisionArr=", pricePrecisionArr[0].toString());
              symbol.pricePrecisionArr = pricePrecisionArr;
              symbolArray.push(symbol);
            });
            this.symbolsData = symbolArray;
            // 初始化currencySymbol 币对基本信息
            if (this.symbolsData.length > 0) {
              for (var el of this.symbolsData) {
                if (el.symbol === this.selectedSymbolObj.symbol) {
                  // 初始化currencySymbol 币对基本信息
                  this.currencySymbol = el;
                  this.selectedPricePrecision = el.pricePrecisionArr[0].toString();
                  this.selectedSymbolObj.baseCurrency = el.baseCurrency;
                  this.selectedSymbolObj.quoteCurrency = el.quoteCurrency;
                  this.baseTabelLabel = "数量(" + el.baseCurrency + ")";
                  this.quoteTabelLabel = "价格(" + el.quoteCurrency + ")";
                  this.totalTabelLabel = "累计数量(" + el.baseCurrency + ")";
                  this.totalAmountTabelLabel = "累计金额(" + el.quoteCurrency + ")";
                  // console.log("this.selectedSymbolObj==", JSON.stringify(this.selectedSymbolObj));
                  break;
                }
              }
              // console.log("获取到的信息是:", this.quoteTabelLabel);
            }
          } else {
            this.$message.error(res.data.errcode + "::" + res.data.errmsg);
            if (res.data.errcode === 3005) {
              // 无效的登录凭证
              this.$router.push("/login");
            }
          }
        })
        .catch((err) => {
          console.log("getSymbol err=", err);
        });
      // // 获取账户资金信息
      // this.getAccounts()
      // // 查询未成交订单
      // this.getOrders('active')
    },

    resolveLevel2Buffer(buffer) {
      // console.log('resolveLevel2Buffer buffer==', buffer)
      if (typeof buffer === "undefined") {
        return;
      }
      var message = exLevel2.ExLevel2.deserializeBinary(buffer);
      var data = message.getData();
      var bidBuffs = data.getBids();
      var askBuffs = data.getAsks();
      var sliceLen = 8 * 1024;
      var bidsStr = "";
      var asksStr = "";
      var i;
      for (i = 0; i < bidBuffs.length / sliceLen; i++) {
        bidsStr += String.fromCharCode.apply(
          null,
          bidBuffs.slice(i * sliceLen, (i + 1) * sliceLen)
        );
      }
      for (i = 0; i < askBuffs.length / sliceLen; i++) {
        asksStr += String.fromCharCode.apply(
          null,
          askBuffs.slice(i * sliceLen, (i + 1) * sliceLen)
        );
      }

      var bidsArray = [];
      var asksArray = [];
      bidsArray = JSON.parse(bidsStr);
      asksArray = JSON.parse(asksStr);
      let bidTableArray = [];
      let askTableArray = [];
      // 买单队列(价格大到小排列)
      for (let index = 0; index < 7; index++) {
        let o = bidsArray[index];
        let totalBid = 0;
        if (index === 0) {
          totalBid = o[1];
        } else {
          totalBid = mathjs
            .add(mathjs.bignumber(o[1]), bidTableArray[index - 1].total)
            .toString();
        }
        let bid = {
          price: o[0],
          qty: o[1],
          total: totalBid
        };
        bidTableArray.push(bid);
      }

      // 卖单队列(价格大到小排列)
      for (let index = 6; index >= 0; index--) {
        let o = asksArray[index];
        let ask = {
          price: o[0],
          qty: o[1],
          total: o[1]
        };
        askTableArray.push(ask);
      }
      for (let i = 5; i >= 0; i--) {
        askTableArray[i].total = mathjs
          .add(
            mathjs.bignumber(askTableArray[i].total),
            mathjs.bignumber(askTableArray[i + 1].total)
          )
          .toString();
      }
      // 赋值表格数据
      this.bidTableData = [];
      this.askTableData = [];
      this.bidTableData = bidTableArray;
      this.askTableData = askTableArray;
    },

    /**
     * 获取深度数据
     */
    async getLevel2() {
      if (this.selectedSymbolObj.symbol === "") {
        return;
      }

      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        symbol: this.selectedSymbolObj.symbol,
        precision: this.selectedPricePrecision
      };
      await API.getLevel2(data)
        .then((res) => {
          // console.log('getLevel2 res==', res);
          if (res.data.errcode === 0) {
            var buffer = res.data.buffer;
            var message = exLevel2.ExLevel2.deserializeBinary(buffer);
            var data = message.getData();
            var bidBuffs = data.getBids();
            var askBuffs = data.getAsks();
            var sliceLen = 8 * 1024;
            var bidsStr = "";
            var asksStr = "";
            var i;
            // console.log("-------bidBuffs=", bidBuffs);
            // 买方深度
            // var bidb = String.fromCharCode.apply(null, bidBuffs);
            // // 卖方深度
            // var askb = String.fromCharCode.apply(null, askBuffs);
            // console.log("bid==", bidb);
            // console.log("askb==", askb);
            for (i = 0; i < bidBuffs.length / sliceLen; i++) {
              bidsStr += String.fromCharCode.apply(
                null,
                bidBuffs.slice(i * sliceLen, (i + 1) * sliceLen)
              );
            }
            // console.log('bidsStr==', bidsStr);
            for (i = 0; i < askBuffs.length / sliceLen; i++) {
              asksStr += String.fromCharCode.apply(
                null,
                askBuffs.slice(i * sliceLen, (i + 1) * sliceLen)
              );
            }
            var bidsArray = [];
            var asksArray = [];
            // 买方深度数组
            bidsArray = JSON.parse(bidsStr);
            // 卖方深度数组
            asksArray = JSON.parse(asksStr);

            let bidTableArray = [];
            let askTableArray = [];
            // 买单队列(价格大到小排列)
            var bidLen;
            if (bidsArray.length < 20) {
              bidLen = bidsArray.length;
            } else {
              bidLen = 20;
            }

            //*******买单队列(价格大到小排列)**********************************/
            // 取20条数据
            for (let index = 0; index < bidLen; index++) {
              let o = bidsArray[index];
              let totalBid = 0;//累计数量
              let totalBidAmount = 0;//累计金额
              // 计算累计数量
              if (index === 0) {
                totalBid = o[1];
                totalBidAmount = mathjs.multiply(mathjs.bignumber(o[0]), mathjs.bignumber(o[1]));
              } else {
                totalBid = mathjs.add(mathjs.bignumber(o[1]), bidTableArray[index - 1].total).toString();
                totalBidAmount = mathjs.add(mathjs.multiply(mathjs.bignumber(o[1]), mathjs.bignumber(o[0])), bidTableArray[index - 1].totalAmount).toString();
              }
              let bid = {
                price: o[0], //价格
                qty: utils.formatDecimal(o[1], this.currencySymbol.basePrecision), //数量
                total: utils.formatDecimal(totalBid, this.currencySymbol.basePrecision), //累计数量
                totalAmount: utils.formatDecimal(totalBidAmount, 4) //utils.formatDecimal(totalBidAmount, this.currencySymbol.basePrecision)//累计金额
              };
              // console.log("bid===", this.currencySymbol.basePrecision, totalBidAmount);
              bidTableArray.push(bid);
            }
            // 赋值表格数据
            this.bidTableData = bidTableArray;
            //*******卖单队列(价格大到小排列)**********************************/
            // 取20条数据
            var askLen;
            if (asksArray.length < 20) {
              askLen = asksArray.length - 1;
            } else {
              askLen = 19;
            }
            for (let index = askLen; index >= 0; index--) {
              let o = asksArray[index];
              let ask = {
                price: o[0], //价格
                qty: utils.formatDecimal(o[1], this.currencySymbol.basePrecision), //数量
                total: utils.formatDecimal(o[1], this.currencySymbol.basePrecision), //累计数量
                totalAmount: 0 //累计金额
              };
              askTableArray.push(ask);
            }
            var askindex = askLen;
            // 计算买盘累计数量
            for (let i = askindex; i >= 0; i--) {
              let totalAsk = 0;//累计数量
              let totalAskAmount = 0;//累计金额
              if (i === askindex) {
                totalAsk = mathjs.bignumber(askTableArray[i].total);
                totalAskAmount = mathjs.multiply(mathjs.bignumber(askTableArray[i].total), mathjs.bignumber(askTableArray[i].price));
              } else {
                totalAsk = mathjs.add(mathjs.bignumber(askTableArray[i].total), mathjs.bignumber(askTableArray[i + 1].total)).toString();
                totalAskAmount = mathjs.add(mathjs.bignumber(askTableArray[i].total) * mathjs.bignumber(askTableArray[i].price), mathjs.bignumber(askTableArray[i + 1].total) * mathjs.bignumber(askTableArray[i + 1].price)).toString();
              }

              askTableArray[i].total = utils.formatDecimal(totalAsk, this.currencySymbol.basePrecision); //累计数量;
              askTableArray[i].totalAmount = utils.formatDecimal(totalAskAmount, 4); //累计金额;
            }
            // 赋值表格数据
            this.askTableData = askTableArray;
            if (this.bidTableData.length > 0 && this.askTableData.length > 0) {
              if (this.sellPriceType) {
                var followsellPrice = "";
                if (this.sellPriceType === 1) {
                  followsellPrice = this.bidTableData[0].price;
                } else if (this.sellPriceType === 2) {
                  // this.buyPrice = this.askTableData[6].price
                  followsellPrice = this.bidTableData[0].price;
                } else if (this.sellPriceType === 3) {
                  followsellPrice = this.askTableData[askLen].price;
                }
                if (this.sellfollow) {
                  this.sellPrice = followsellPrice;
                }
                if (this.sellPrice === 0) {
                  this.sellPrice = followsellPrice;
                }
              }

              if (this.buyPriceType) {
                var followbuyPrice = "";
                if (this.buyPriceType === 1) {
                  followbuyPrice = this.askTableData[askLen].price;
                } else if (this.buyPriceType === 2) {
                  // this.buyPrice = this.askTableData[6].price
                  followbuyPrice = this.askTableData[askLen].price;
                } else if (this.buyPriceType === 3) {
                  followbuyPrice = this.bidTableData[0].price;
                }
                if (this.buyfollow) {
                  this.buyPrice = followbuyPrice;
                }
                if (this.buyPrice === 0) {
                  this.buyPrice = followbuyPrice;
                }
              }
            }
          } else if (res.data.errcode === 3005) {
            // 无效的登录凭证
            // console.log('getLevel2 errmsg', res.data.errcode + '-' + res.data.errmsg)
            this.$message.error(res.data.errcode + ":level" + res.data.errmsg);
            clearInterval(this.getDeepDataInterval);
            this.$router.push("/login");
          }
        })
        .catch((err) => {
          clearInterval(this.getDeepDataInterval);
          this.$message.error("获取行情出错：" + err);
        });
    },

    /**
     * 获取深度数据
     * 实现价格精度聚合
     */
    async getLevel2_new() {
      if (this.selectedSymbolObj.symbol === "") {
        return;
      }
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        symbol: this.selectedSymbolObj.symbol,
        precision: "0"
      };
      await API.getLevel2(data).then((res) => {
        // console.log('getLevel2 res==', res);
        if (res.data.errcode === 0) {
          let buffer = res.data.buffer;
          let message = exLevel2.ExLevel2.deserializeBinary(buffer);
          let data = message.getData();
          let bidBuffs = data.getBids();
          let askBuffs = data.getAsks();
          // let id = data.getSequence();
          let sliceLen = 8 * 1024;
          let bidsStr = "";
          let asksStr = "";
          let i;
          // 买方深度
          // let bidb = String.fromCharCode.apply(null, bidBuffs);
          // 卖方深度
          // let askb = String.fromCharCode.apply(null, askBuffs);
          for (i = 0; i < bidBuffs.length / sliceLen; i++) {
            bidsStr += String.fromCharCode.apply(
              null,
              bidBuffs.slice(i * sliceLen, (i + 1) * sliceLen)
            );
          }

          for (i = 0; i < askBuffs.length / sliceLen; i++) {
            asksStr += String.fromCharCode.apply(
              null,
              askBuffs.slice(i * sliceLen, (i + 1) * sliceLen)
            );
          }
          // console.log('bidsStr==', bidsStr);
          let bidsArray = [];
          let asksArray = [];
          // 买方深度数组
          bidsArray = JSON.parse(bidsStr);
          // 卖方深度数组
          asksArray = JSON.parse(asksStr);
          // console.log("sequence===", id, bidsArray[0]);
          // console.log("fffffffffffffthis.selectedPricePrecision=", this.selectedPricePrecision);
          // console.log("this.currencySymbol.priceIncrease===", this.currencySymbol.priceIncrease);
          // console.log("this.currencySymbol.pricePrecision===", this.currencySymbol.pricePrecision);
          // 算出与价格精度标准精度的倍数
          let mul = mathjs.divide(mathjs.bignumber(this.selectedPricePrecision), mathjs.bignumber(this.currencySymbol.priceIncrease));
          // 新价格精度
          let newPricePrecision = this.currencySymbol.pricePrecision;
          if (mul.toString() === "10") {
            // 价格精度-1
            newPricePrecision = mathjs.subtract(this.currencySymbol.pricePrecision, 1);
          } else if (mul.toString() === "100") {
            // 价格精度-2
            newPricePrecision = mathjs.subtract(this.currencySymbol.pricePrecision, 2);
          }
          // console.log("newPricePrecision===", newPricePrecision);
          if (bidsArray.length > 0) {
            this.dealBidsData(bidsArray, newPricePrecision);
          }

          if (asksArray.length > 0) {
            this.dealAsksData(asksArray, newPricePrecision);
          }
        } else if (res.data.errcode === 3005) {
          // 无效的登录凭证
          // console.log('getLevel2 errmsg', res.data.errcode + '-' + res.data.errmsg)
          this.$message.error(res.data.errcode + ":level" + res.data.errmsg);
          clearInterval(this.getDeepDataInterval);
          this.$router.push("/login");
        }
      })
        .catch((err) => {
          clearInterval(this.getDeepDataInterval);
          this.$message.error("获取行情出错：" + err);
        });
    },

    /**
     * 处理买单深度数据（价格精度聚合）
     * @param {*} bidsArray 深度数组
     * @param {*} newPricePrecision 新的价格精度 1,2,3，
     */
    dealBidsData(bidsArray, newPricePrecision) {
      // 按新精度，重新计算价格
      for (let index = 0; index < bidsArray.length; index++) {
        bidsArray[index][0] = utils.truncateNumber(bidsArray[index][0], newPricePrecision);
      }
      // 将相同价格的深度数据数量累计
      let priceSums = {};
      bidsArray.forEach(element => {
        if (mathjs.bignumber(element[0]) in priceSums) {
          priceSums[mathjs.bignumber(element[0])] = mathjs.add(priceSums[mathjs.bignumber(element[0])], mathjs.bignumber(element[1]));
        } else {
          priceSums[mathjs.bignumber(element[0])] = mathjs.bignumber(element[1]);
        }
      });
      let newBidsArray = [];
      newBidsArray = Object.keys(priceSums).map(price => [mathjs.bignumber(price), priceSums[price]]);
      // console.log("newBidsArray====", newBidsArray);

      // 排序（按价格有大到小排序）
      newBidsArray.sort((a, b) => b[0] - a[0]);

      let bidTableArray = [];
      // 循环计算每条深度数据的累计数量，累计金额
      for (let index = 0; index < newBidsArray.length; index++) {
        let obj = newBidsArray[index];
        let totalBidNum = 0; //累计数量
        let totalBidAmount = 0;//累计金额
        // console.log("o===", o);
        if (index === 0) {
          totalBidNum = obj[1];
          totalBidAmount = mathjs.multiply(mathjs.bignumber(obj[0]), mathjs.bignumber(obj[1]));
        } else {
          totalBidNum = mathjs.add(mathjs.bignumber(obj[1]), bidTableArray[index - 1].total).toString();
          totalBidAmount = mathjs.add(mathjs.multiply(mathjs.bignumber(obj[1]), mathjs.bignumber(obj[0])), bidTableArray[index - 1].totalAmount).toString();
        }
        let bid = {
          price: obj[0], //价格
          qty: utils.formatDecimal(obj[1], this.currencySymbol.basePrecision), //数量
          total: utils.formatDecimal(totalBidNum, this.currencySymbol.basePrecision), //累计数量
          totalAmount: utils.formatDecimal(totalBidAmount, 4) //utils.formatDecimal(totalBidAmount, this.currencySymbol.basePrecision)//累计金额
        };
        bidTableArray.push(bid);
      }

      this.bidTableData = bidTableArray.slice(0, 17);
    },

    /**
     * 处理卖单深度数据（价格精度聚合）
     * @param {*} asksArray
     * @param {*} priceIncrease 价格步长 0.001
     */
    dealAsksData(asksArray, newPricePrecision) {
      // 排序（按价格有大到小排序）
      // asksArray.sort((a, b) => b[0] - a[0]);
      // 按新精度，重新计算价格
      for (let index = 0; index < asksArray.length; index++) {
        asksArray[index][0] = utils.truncateNumber(asksArray[index][0], newPricePrecision);
      }
      // 将相同价格的深度数据数量累计
      let priceSums = {};
      asksArray.forEach(element => {
        if (mathjs.bignumber(element[0]) in priceSums) {
          priceSums[mathjs.bignumber(element[0])] = mathjs.add(priceSums[mathjs.bignumber(element[0])], mathjs.bignumber(element[1]));
        } else {
          priceSums[mathjs.bignumber(element[0])] = mathjs.bignumber(element[1]);
        }
      });
      let newAsksArray = [];
      newAsksArray = Object.keys(priceSums).map(price => [mathjs.bignumber(price), priceSums[price]]);
      // console.log("newAsksArray====", newAsksArray);
      // 先排序（按价格有小到大排序）
      newAsksArray.sort((a, b) => a[0] - b[0]);
      //console.log("newAsksArray的长度是：", newAsksArray.length);
      let askTableArray = [];
      // 循环计算每条深度数据的累计数量，累计金额
      for (let index = 0; index < newAsksArray.length; index++) {
        let obj = newAsksArray[index];
        let totalAskNum = 0; //累计数量
        let totalAskAmount = 0;//累计金额
        if (index === 0) {
          totalAskNum = obj[1];
          totalAskAmount = mathjs.multiply(mathjs.bignumber(obj[0]), mathjs.bignumber(obj[1]));
        } else {
          totalAskNum = mathjs.add(mathjs.bignumber(obj[1]), askTableArray[index - 1].total).toString();
          totalAskAmount = mathjs.add(mathjs.multiply(mathjs.bignumber(obj[1]), mathjs.bignumber(obj[0])), askTableArray[index - 1].totalAmount).toString();
        }
        let ask = {
          price: obj[0], //价格
          qty: utils.formatDecimal(obj[1], this.currencySymbol.basePrecision), //数量
          total: utils.formatDecimal(totalAskNum, this.currencySymbol.basePrecision), //累计数量
          totalAmount: utils.formatDecimal(totalAskAmount, 4) //utils.formatDecimal(totalBidAmount, this.currencySymbol.basePrecision)//累计金额
        };
        askTableArray.push(ask);
      }
      // 再排序（按价格有大到小排序）
      askTableArray.sort((a, b) => b.price - a.price);
      this.askTableData = this.askTableData = askTableArray.slice(-18);
    },

    /**
     * 获取exchange
     */
    async getExchangesList() {
      var data = {
        'uid': localStorage.getItem("userName")
      };
      API.getExchangesLista(data).then(res => {
        // console.log("--------------"+JSON.stringify(res.data))
        if (res.data) {
          this.exchangeList = res.data;
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
        }
      });
    },

    // 获取账户资金信息
    getAccounts() {
      // console.log('getAccounts----------')
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        currency: "",
        type: "",
        exchange: this.selectedSymbolObj.exchange
      };
      API.getAccounts(data).then((res) => {
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exAccounts.ExAccounts.deserializeBinary(buffer);
          var accountTableArray = [];

          message.getDataList().forEach((element) => {
            var data = {
              currency: element.getCurrency(),
              type: element.getType(),
              balance: element.getBalance(),
              available: element.getAvailable(),
              holds: element.getHolds()
            };

            accountTableArray.push(data);
            if (
              element.getCurrency() === this.selectedSymbolObj.baseCurrency &&
              (element.getType() === "trade" || element.getType() === "")
            ) {
              this.selectedSymbolObj.baseCurrencyAvailable =
                element.getAvailable();
            }
            if (
              element.getCurrency() === this.selectedSymbolObj.quoteCurrency &&
              (element.getType() === "trade" || element.getType() === "")
            ) {
              this.selectedSymbolObj.quoteCurrencyAvailable =
                element.getAvailable();
            }

          });
          // 去重
          var transferTableArray = [];
          var obj = {};
          for (var i = 0; i < accountTableArray.length; i++) {
            if (!obj[accountTableArray[i].currency]) {
              transferTableArray.push(accountTableArray[i]);
              obj[accountTableArray[i].currency] = true;
            }
          }
          this.accountTableData = accountTableArray;
          this.transferTableData = transferTableArray;
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
        }
      });
    },

    // 资金划转
    InnerTransfer(index, row) {
      // console.log('InnerTransfer=', row)
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        currency: row.currency,
        amount: row.amount,
        direct: parseInt(row.direct) // 0、主账号->交易账号（默认） 1、交易账号->主账号
      };
      API.InnerTransfer(data).then((res) => {
        if (res.data.errcode === 0) {
          // this.getAccounts()
          this.$message({
            message: "划转成功！",
            type: "success"
          });
          this.getAccounts();
        } else if (res.data.errcode === 230003) {
          this.$message({
            message: "账户资金总额不足",
            type: "error"
          });
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
        }
      });
    },

    /**
     * 获取委托订单信息
     */
    getOrders(flag, currentPage) {
      // this.orderTableData = []
      this.pageConfig.currentPage = Math.abs(parseInt(currentPage));
      //对不支持分页的单独处理，取最大数量
      let exchange = this.selectedSymbolObj.exchange;
      if (exchange === 3 || exchange === 6 || exchange === 8 || exchange === 10 || exchange === 11 || exchange === 12 || exchange === 15 || exchange === 16 || exchange === 20|| exchange === 27) {
        this.pageConfig.pageSize = 500;
      } else {
        this.pageConfig.pageSize = 10;
      }
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        status: flag,
        side: this.side,
        symbol: this.selectedSymbolObj.symbol,
        currentPage: currentPage.toString(),
        pageSize: this.pageConfig.pageSize + ""
      };
      API.getOrders(data).then((res) => {
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exQryOrders.ExQryOrders.deserializeBinary(buffer);
          var orderData = message.getData();
          this.pageConfig.totalPage = orderData.getTotalpage();
          if (orderData.getCurrentpage > 0) {
            this.pageConfig.currentPage = orderData.getCurrentpage();
          }
          var orderTableArray = [];
          orderData.getItemsList().forEach((element) => {
            var orderInfo = {
              id: element.getId(),
              intId: element.getIntid(),
              symbol: element.getSymbol(),
              opType: element.getOptype(),
              type: element.getType().toLowerCase(),
              side: element.getSide().toLowerCase(),
              price: element.getPrice(),
              size: element.getSize(),
              funds: element.getFunds(),
              createAt:
                element.getCreatedat() === 0
                  ? ""
                  : utils.dateFormat(element.getCreatedat()),
              cancelExist: element.getCancelexist(),
              isActive: element.getIsactive(),
              clientOid: element.getClientoid(),
              iceberg: element.getIceberg(),
              visibleSize: element.getVisiblesize(),
              hidden: element.getHidden(),
              postOnly: element.getPostonly(),
              timeInForce: element.getTimeinforce(),
              dealFunds: element.getDealfunds(),
              dealSize: element.getDealsize(),
              tradeType: element.getTradetype()
            };
            // 处理委托金额
            let fund = 0;
            fund = mathjs.multiply(
              mathjs.bignumber(element.getPrice()),
              mathjs.bignumber(element.getSize())
            );
            if (!this.currencySymbol.quotePrecision) {
              orderInfo.funds = fund;
            } else {
              orderInfo.funds = utils.formatDecimal(
                fund,
                this.currencySymbol.quotePrecision
              );
            }
            orderTableArray.push(orderInfo);
          });
          if (this.side) {
            orderTableArray = orderTableArray.filter((r) => {
              let row = r.side;
              return row.includes(this.side);
            });
          }
          this.orderTableData = [];

          var orderLen = orderData.getItemsList().length;
          this.pageConfig.totalNum = orderLen;
          this.tableData = orderTableArray;
          let pageSize = 10;
          if (data.currentPage === "1") {
            if (orderLen > pageSize) {
              let start = (data.currentPage - 1) * pageSize;
              let end = data.currentPage * pageSize;
              this.orderTableData = orderTableArray.slice(start, end);
            } else {
              this.orderTableData = orderTableArray;
            }
          } else {
            this.orderTableData = orderTableArray;
          }
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
          if (res.data.errcode === 4004) {
            this.pageConfig.currentPage = this.pageConfig.currentPage - 1;
          }
        }
      });
    },

    /**
     * // 获取24小时成交
     */
    getFills(currentPage) {
      var now = new Date();
      this.pageConfig.currentPage = Math.abs(parseInt(currentPage));
      //对不支持分页的单独处理，取最大数量
      let exchange = this.selectedSymbolObj.exchange;
      if (exchange === 3 || exchange === 6 || exchange === 8 || exchange === 10 || exchange === 11 || exchange === 12 || exchange === 15 || exchange === 16 || exchange === 20 || exchange === 27) {
        this.pageConfig.pageSize = 1000;
      } else {
        this.pageConfig.pageSize = 10;
      }
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        symbol: this.selectedSymbolObj.symbol,
        side: this.side,
        currentPage: currentPage.toString(),
        pageSize: this.pageConfig.pageSize + "",
        startAt: now.getTime() - 1 * 60 * 60 * 1000,
        // endAt: now.getTime(),
        tradeType: "TRADE"
      };
      API.getFills(data).then((res) => {
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exQryFills.ExQryFills.deserializeBinary(buffer);
          // console.log(message);
          var fillsDataArray = [];
          var fillsData = message.getData();
          // this.pageConfig.totalNum = fillsData.getTotalnum()
          this.pageConfig.totalPage = fillsData.getTotalpage();
          // this.pageConfig.currentPage = fillsData.getCurrentpage()
          fillsData.getItemsList().forEach((element) => {
            var data = {
              symbol: element.getSymbol(), // 交易对
              tradeId: element.getTradeid(), // 交易id
              tradeIntId: element.getTradeintid(),
              orderId: element.getOrderid(), // 订单id
              counterOrderId: element.getCounterorderid(), // 对手方订单id
              side: element.getSide().toLowerCase(), // buy/sell
              forceTaker: element.getForcetaker(), // 是否强制作为taker处理
              liquidity: element.getLiquidity(), // taker或maker
              price: element.getPrice(), // 订单价格
              size: element.getSize(), // 下单数量
              funds: element.getFunds(), // 下单金额
              fee: element.getFee(), // 手续费
              feeRate: element.getFeerate(), // 手续费率
              feeCurrency: element.getFeecurrency(), // 计手续费币种
              stop: element.getStop(), // 止损止盈类型, entry:止盈 loss:止损
              type: element.getType().toLowerCase(), // limit 或 market
              createAt:
                element.getCreatedat() === 0
                  ? ""
                  : utils.dateFormat(element.getCreatedat()), // 创建时间
              tradeType: element.getTradetype(), // 交易类型: TRADE, MARGIN_TRADE
              ordercreateAt: ""
            };

            // 处理成交金额
            let fund = 0;
            fund = mathjs.multiply(
              mathjs.bignumber(element.getPrice()),
              mathjs.bignumber(element.getSize())
            );
            if (!this.currencySymbol.quotePrecision) {
              data.funds = fund;
            } else {
              data.funds = utils.formatDecimal(
                fund,
                this.currencySymbol.quotePrecision
              );
            }
            fillsDataArray.push(data);
          });
          if (this.side) {
            fillsDataArray = fillsDataArray.filter((r) => {
              let row = r.side;
              return row.includes(this.side);
            });
          }
          this.fillsTableData = [];
          var fillLen = fillsData.getItemsList().length;
          this.pageConfig.totalNum = fillLen;
          this.tableData = fillsDataArray;
          let pageSize = 10;
          if (fillLen > pageSize) {
            let start = (data.currentPage - 1) * pageSize;
            let end = data.currentPage * pageSize;
            this.fillsTableData = fillsDataArray.slice(start, end);
          } else {
            this.fillsTableData = fillsDataArray;
          }
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
          if (res.data.errcode === 4004) {
            this.pageConfig.currentPage = this.pageConfig.currentPage - 1;
          }
        }
      });
    },

    /**
     * 持仓查询
     */
    getHolds() {
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        symbol: this.selectedSymbolObj.symbol
      };
      API.getHolds(data).then((res) => {
        // console.log("res==", res);
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exQryHolds.ExHolds.deserializeBinary(buffer);
          // console.log("message=", message);
          // console.log("message=", JSON.stringify(message));
          let holdsDataArray = [];
          // let holdsData = message.getDataList();
          message.getDataList().forEach((element) => {
            var data = {
              symbol: element.getSymbol(),
              holdId: element.getHoldid(),
              holdSide: element.getHoldside(),
              holdPrice: element.getHoldprice(),
              holdSz: element.getHoldsz(),
              openBal: element.getOpenbal(),
              holdBal: element.getHoldbal(),
              ccy: element.getCcy(),
              cTime: element.getCtime(),
              uTime: element.getUtime(),
              mgnMode: element.getMgnmode(),
              leverage: element.getLeverage()
            };
            holdsDataArray.push(data);
          });
          this.holdsTableData = holdsDataArray;
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
          if (res.data.errcode === 4004) {
            this.pageConfig.currentPage = this.pageConfig.currentPage - 1;
          }
        }
      });
    },

    /**
     * 买入下单
     */
    insertOrderBuy() {
      var data = {};
      if (this.buyPriceType === 1) {
        // 市价单
        if (this.buyAmount === 0) {
          return;
        }
        data = {
          uid: localStorage.getItem("userName"),
          apiId: this.selectedSymbolObj.apiId,
          exchange: this.selectedSymbolObj.exchange,
          side: "buy",
          symbol: this.selectedSymbolObj.symbol,
          funds: this.buyAmount.toString()
        };
        API.insertMarketOrder(data).then((res) => {
          // console.log('insertMarketOrder res==', res)
          if (res.data.errcode === 0) {
            this.$message({
              message: "下单成功！",
              type: "success"
            });
            if (this.activetabName === "first") {
              this.getAccounts();
              this.getOrders("active", "1");
            } else if (this.activetabName === "second") {
              this.getAccounts();
              this.getOrders("done", "1");
            } else if (this.activetabName === "ten") {
              this.getHolds();
            }
          } else {
            this.$message.error(res.data.errcode + ":" + res.data.errmsg);
            if (res.data.errcode === 3005) {
              // 无效的登录凭证
              this.$router.push("/login");
            }
          }
        });
      } else {
        // 限价单
        if (this.buyNum === 0) {
          return;
        }
        data = {
          uid: localStorage.getItem("userName"),
          apiId: this.selectedSymbolObj.apiId,
          exchange: this.selectedSymbolObj.exchange,
          side: "buy",
          symbol: this.selectedSymbolObj.symbol,
          price: utils.toNonExponential(this.buyPrice).toString(),
          size: this.buyNum.toString(),
          timeInForce: this.buyTypeRadio,
          postOnly: this.buyPostOnly,
          hidden: this.buyHiddenChecked,
          iceberg: this.buyIcebergChecked,
          visibleSize: this.buyIcebergNum + "",
          tradetype: this.buyReduceOnly ? "true" : "false"
        };

        API.insertLimitOrder(data).then((res) => {
          // console.log('insertLimitOrder res==', res)
          if (res.data.errcode === 0) {
            if (this.activetabName === "first") {
              this.getAccounts();
              this.getOrders("active", "1");
            } else if (this.activetabName === "second") {
              this.getAccounts();
              this.getOrders("done", "1");
            }
            this.$message({
              message: "下单成功！",
              type: "success"
            });
          } else {
            this.$message.error(res.data.errcode + ":" + res.data.errmsg);
            if (res.data.errcode === 3005) {
              // 无效的登录凭证
              this.$router.push("/login");
            }
          }
        });
      }
    },

    /**
     * 卖出下单
     */
    insertOrderSell() {
      var data = {};
      if (this.sellPriceType === 1) {
        // 市价单
        data = {
          uid: localStorage.getItem("userName"),
          apiId: this.selectedSymbolObj.apiId,
          exchange: this.selectedSymbolObj.exchange,
          side: "sell",
          symbol: this.selectedSymbolObj.symbol,
          size: this.sellNum.toString()
        };
        API.insertMarketOrder(data).then((res) => {
          // console.log('insertOrder res==', res)
          if (res.data.errcode === 0) {
            if (this.activetabName === "first") {
              this.getAccounts();
              this.getOrders("active", "1");
            } else if (this.activetabName === "second") {
              this.getAccounts();
              this.getOrders("done", "1");
            }
            this.$message({
              message: "下单成功！",
              type: "success"
            });
          } else {
            this.$message.error(res.data.errcode + ":" + res.data.errmsg);
            if (res.data.errcode === 3005) {
              // 无效的登录凭证
              this.$router.push("/login");
            }
          }
        });
      } else {
        // 限价单
        data = {
          uid: localStorage.getItem("userName"),
          apiId: this.selectedSymbolObj.apiId,
          exchange: this.selectedSymbolObj.exchange,
          side: "sell",
          symbol: this.selectedSymbolObj.symbol,
          price: utils.toNonExponential(this.sellPrice).toString(),
          size: this.sellNum.toString(),
          timeInForce: this.sellTypeRadio,
          postOnly: this.sellPostOnly,
          tradeType: this.sellReduceOnly ? "true" : "false",
          hidden: this.sellHiddenChecked,
          iceberg: this.sellIcebergChecked,
          visibleSize: this.sellIcebergNum + ""
        };
        API.insertLimitOrder(data).then((res) => {
          // console.log('insertOrder res==', res)
          if (res.data.errcode === 0) {
            // console.log('insertOrder message==', message)
            if (this.activetabName === "first") {
              this.getAccounts();
              this.getOrders("active", "1");
            } else if (this.activetabName === "second") {
              this.getAccounts();
              this.getFills("1");
            }
            this.$message({
              message: "下单成功！",
              type: "success"
            });
          } else {
            this.$message.error(res.data.errcode + ":" + res.data.errmsg);
            if (res.data.errcode === 3005) {
              // 无效的登录凭证
              this.$router.push("/login");
            }
          }
        });
      }
    },

    // 撤单
    deleteOrderByOrderId() {
      if (this.selectedOrderId === "") {
        this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return;
      }
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        orderId: this.selectedOrderId,
        symbol: this.selectedSymbolObj.symbol
      };
      API.deleteOrderByOrderId(data).then((res) => {
        // console.log('deleteOrderByOrderId res==', res)
        if (res.data.errcode === 0) {
          // var buffer = res.data.buffer
          // var message = exDeleteOrder.ExDeleteOrder.deserializeBinary(buffer)
          // // console.log('deleteOrderByOrderId message==', message)
          // var deleteOrderData = message.getData()
          // deleteOrderData.getCancelledorderidsList().forEach(element => {
          //   // console.log('element=', element)
          // })
          this.$message({
            type: "success",
            message: "撤单成功!"
          });
          this.orderTableData.splice(
            this.orderTableData.indexOf(this.selectedRow),
            1
          );
          // this.getOrders('active', '1')
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
        }
      });
    },

    // 全部撤单
    deleteOrderBySymbol() {
      if (this.selectedSymbolObj.symbol === "") {
        this.$notify({
          title: "提示",
          message: "币对为空",
          type: "warning"
        });
        return;
      }
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        symbol: this.selectedSymbolObj.symbol
      };
      API.deleteOrderBySymbol(data).then((res) => {
        // console.log('deleteOrderBySymbol res==', res)
        if (res.data.errcode === 0) {
          // var message = exDeleteOrder.ExDeleteOrder.deserializeBinary(buffer)
          // var deleteOrderData = message.getData()
          // deleteOrderData.getCancelledorderidsList().forEach(element => {
          //   // console.log('element=', element)
          // })
          this.getOrders("active", "1");
          this.$message({
            type: "success",
            message: "全部撤单成功!"
          });
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
        }
      });
    },

    /**
     * 订阅level2行情
     */
    subLevel2() {
      var data = {
        op: "sub",
        symbol: this.selectedSymbolObj.symbol,
        depth: 7,
        exchange: "5"
      };
      this.$WS.initWebSocket();
      this.$WS.sendSocket(data);
    },

    /**
     * 初始化函数
     */
    async init() {
      // 整页Loading
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      // 获取api及币对菜单 await:等待方法执行完成
      await this.getMenuData();
      // 选择默认菜单、默认币对
      this.defaultMenu();
      // 获取所有交易币对信息
      await this.getSymbol();
      //  获取账户资金信息
      this.getAccounts();
      // 查询未成交委托订单
      this.getOrders("active", "1");
      //
      this.confirmChecked = localStorage.getItem("confirmval") === "true";
      this.loading.close();
      // 开始行情
      this.startLevel2();
    },

    /**
     * 定时查询深度行情
     * 间隔时间2秒
     */
    startLevel2() {
      // 定时查询深度行情
      var self = this;
      if (this.selectedSymbolObj.exchangeName === "GATEIO") {
        // 交易所支持精度聚合
        self.getLevel2().then(() => {
          //console.log(this.askTableData);
          self.$refs.askTableRef.bodyWrapper.scrollTop = self.$refs.askTableRef.bodyWrapper.scrollHeight;
          self.$refs.askTableRef1.bodyWrapper.scrollTop = self.$refs.askTableRef1.bodyWrapper.scrollHeight;
        });
        self.getDeepDataInterval = setInterval(function () {
          self.getLevel2();
        }, 2 * 1000);
      } else {
        // 本地前段精度聚合
        self.getLevel2_new().then(() => {
          //console.log(this.askTableData);
          self.$refs.askTableRef.bodyWrapper.scrollTop = self.$refs.askTableRef.bodyWrapper.scrollHeight;
          self.$refs.askTableRef1.bodyWrapper.scrollTop = self.$refs.askTableRef1.bodyWrapper.scrollHeight;
        });
        self.getDeepDataInterval = setInterval(function () {
          self.getLevel2_new();
        }, 2 * 1000);
      }
    },

    /**
     * 停止定时器
     */
    stopLevel2() {
      clearInterval(this.getDeepDataInterval);
    },

    // 筛选方向
    filterChange(val) {
      let column = val.side;
      if (column.length === 1) {
        // 单选
        this.side = column[0];
      } else {
        // 多选传空值
        this.side = "";
      }
      if (this.activetabName === "first") {
        this.getOrders("active", "1");
      } else if (this.activetabName === "second") {
        this.getFills("1");
      }
    },

    initSplitPrice() {
      if (this.bidTableData.length > 0 && this.askTableData.length > 0) {
        this.splitForm.startPrice = this.bidTableData[0].price;
        this.splitForm.endPrice = this.askTableData[this.askTableData.length - 1].price;
      }
    },

    useSplitFun() {
      if (this.countFloat === 0) {
        this.calculateSplit();
      } else {
        this.floatSplit();
        for (let i = 0; i < 10; i++) {
          if (this.splitOrders[0].amount <= 0) {
            this.floatSplit();
          } else {
            break;
          }
        }
      }
    },

    calculateSplit() {
      const { startPrice, endPrice, amount, orderCount } = this.splitForm;

      if (!startPrice || !endPrice || !amount || orderCount < 2) {
        return;
      }

      if (startPrice > endPrice) {
        this.$message.warning('开始价格必须小于结束价格');
        return;
      }

      const orders = [];
      const priceStep = (endPrice - startPrice) / (orderCount - 1);
      const avgAmount = amount / orderCount;
      let totalPrice = 0;

      for (let i = 0; i < orderCount; i++) {
        const price = startPrice + priceStep * i;
        const orderAmount = avgAmount;
        const percentage = ((orderAmount / amount) * 100).toFixed(2);

        orders.push({
          price: price.toFixed(this.currencySymbol.pricePrecision),
          amount: orderAmount.toFixed(this.currencySymbol.basePrecision),
          percentage: percentage
        });

        totalPrice += price * orderAmount;
      }

      this.splitOrders = orders;
      this.splitSummary.avgPrice = (totalPrice / amount).toFixed(this.currencySymbol.pricePrecision);
      this.splitSummary.totalCost = (totalPrice).toFixed(this.currencySymbol.amountPrecision);
    },

    floatSplit() {
      const { startPrice, endPrice, amount, orderCount } = this.splitForm;

      if (!startPrice || !endPrice || !amount || orderCount < 2) {
        return;
      }

      if (startPrice > endPrice) {
        this.$message.warning('开始价格必须小于结束价格');
        return;
      }

      const orders = [];
      const priceStep = (endPrice - startPrice) / (orderCount - 1);
      const avgAmount = amount / orderCount;
      const minAmount = (avgAmount * (1 - (this.countFloat / 100))).toFixed(this.currencySymbol.basePrecision);
      const maxAmount = (avgAmount * (1 + (this.countFloat / 100))).toFixed(this.currencySymbol.basePrecision);

      let allAmount = new Decimal(0);

      const minAmountNum = Number(minAmount);
      const maxAmountNum = Number(maxAmount);
      for (let i = 0; i < orderCount; i++) {
        const price = startPrice + priceStep * i;
        const orderAmount = (Math.random() * (maxAmountNum - minAmountNum) + minAmountNum).toFixed(this.currencySymbol.basePrecision);

        orders.push({
          price: price.toFixed(this.currencySymbol.pricePrecision),
          amount: orderAmount,
          percentage: 0
        });

        allAmount = allAmount.add(new Decimal(orderAmount));
      }

      if (!allAmount.equals(amount)) {
        if (allAmount.greaterThan(amount)) {
          let diff = allAmount.minus(new Decimal(amount));
          let s = diff.div(new Decimal(orderCount));
          let adjustedSum = new Decimal(0);
          for (let i = 0; i < orderCount - 1; i++) {
            let a = new Decimal(orders[i].amount).minus(s).toFixed(this.currencySymbol.basePrecision);
            orders[i].amount = a;
            adjustedSum = adjustedSum.add(new Decimal(a));
          }
          orders[orderCount - 1].amount = new Decimal(amount).minus(adjustedSum).toFixed(this.currencySymbol.basePrecision);
        } else {
          let diff = new Decimal(amount).minus(allAmount);
          let s = diff.div(new Decimal(orderCount));
          let adjustedSum = new Decimal(0);
          for (let i = 0; i < orderCount - 1; i++) {
            let a = new Decimal(orders[i].amount).add(s).toFixed(this.currencySymbol.basePrecision);
            orders[i].amount = a;
            adjustedSum = adjustedSum.add(new Decimal(a));
          }
          orders[orderCount - 1].amount = new Decimal(amount).minus(adjustedSum).toFixed(this.currencySymbol.basePrecision);
        }
      }

      for (let j = 0; j < 10; j++) {
        let outAmount = new Decimal(0);
        for (let i = 0; i < orderCount; i++) {
          if (new Decimal(orders[i].amount).greaterThan(maxAmount)) {
            let a = (Math.random() * (maxAmountNum - minAmountNum) + minAmountNum).toFixed(this.currencySymbol.basePrecision);
            outAmount = outAmount.add(new Decimal(orders[i].amount).minus(new Decimal(a)));
            orders[i].amount = a;
          }
        }
        if (outAmount.equals(0)) {
          break;
        } else {
          let s = outAmount.div(new Decimal(orderCount));
          let adjustedSum = new Decimal(0);
          for (let i = 0; i < orderCount - 1; i++) {
            let a = new Decimal(orders[i].amount).minus(s).toFixed(this.currencySymbol.basePrecision);
            orders[i].amount = a;
            adjustedSum = adjustedSum.add(new Decimal(a));
          }
          orders[orderCount - 1].amount = new Decimal(amount).minus(adjustedSum).toFixed(this.currencySymbol.basePrecision);
        }
      }

      let totalPrice = 0;
      for (let i = 0; i < orderCount; i++) {
        const percentage = ((orders[i].amount / amount) * 100).toFixed(2);
        orders[i].percentage = percentage;
        totalPrice += Number(orders[i].amount) * Number(orders[i].price);
      }

      this.splitOrders = orders;
      this.splitSummary.avgPrice = (totalPrice / amount).toFixed(this.currencySymbol.pricePrecision);
      this.splitSummary.totalCost = (totalPrice).toFixed(this.currencySymbol.amountPrecision);
    },

    resetSplitForm() {
      this.splitForm = {
        startPrice: 0,
        endPrice: 0,
        amount: 0,
        orderCount: 1
      };
      this.splitOrders = [];
      this.splitSummary = {
        avgPrice: 0,
        totalCost: 0
      };
    },

    splitBuyClick() {
      console.log(this.splitSummary.totalCost, this.selectedSymbolObj.quoteCurrencyAvailable);
      if (this.splitSummary.totalCost > Number.parseFloat(this.selectedSymbolObj.quoteCurrencyAvailable)) {
        this.$message.warning("可用余额不足");
        return;
      }
      this.batchOrderBuy();
    },

    splitSellClick() {
      if (this.splitForm.amount > Number.parseFloat(this.selectedSymbolObj.baseCurrencyAvailable)) {
        this.$message.warning("可用余额不足");
        return;
      }
      this.batchOrderSell();
    },

    batchOrderBuy() {
      if (this.timeoutNum > this.splitOrders.length - 1) {
        this.timeoutNum = 0;
        return;
      }

      var data = {};
      if (this.splitOrders[this.timeoutNum].amount === 0) {
        return;
      }
      data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        side: "buy",
        symbol: this.selectedSymbolObj.symbol,
        price: this.splitOrders[this.timeoutNum].price.toString(),
        size: this.splitOrders[this.timeoutNum].amount.toString(),
        timeInForce: this.buyTypeRadio,
        postOnly: this.buyPostOnly,
        hidden: this.buyHiddenChecked,
        iceberg: this.buyIcebergChecked,
        visibleSize: this.buyIcebergNum + "",
        tradetype: this.buyReduceOnly ? "true" : "false"
      };

      API.insertLimitOrder(data).then((res) => {
        if (res.data.errcode === 0) {
          if (this.activetabName === "first") {
            this.getAccounts();
            this.getOrders("active", "1");
          } else if (this.activetabName === "second") {
            this.getAccounts();
            this.getOrders("done", "1");
          }
          this.$message({
            message: "下单成功！",
            type: "success"
          });
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            this.$router.push("/login");
          }
        }
      });

      this.timeoutNum += 1;

      setTimeout(() => {
        this.batchOrderBuy();
      }, 200);
    },

    batchOrderSell() {
      if (this.timeoutNum > this.splitOrders.length - 1) {
        this.timeoutNum = 0;
        return;
      }

      var data = {};
      data = {
        uid: localStorage.getItem("userName"),
        apiId: this.selectedSymbolObj.apiId,
        exchange: this.selectedSymbolObj.exchange,
        side: "sell",
        symbol: this.selectedSymbolObj.symbol,
        price: this.splitOrders[this.timeoutNum].price.toString(),
        size: this.splitOrders[this.timeoutNum].amount.toString(),
        timeInForce: this.sellTypeRadio,
        postOnly: this.sellPostOnly,
        tradeType: this.sellReduceOnly ? "true" : "false",
        hidden: this.sellHiddenChecked,
        iceberg: this.sellIcebergChecked,
        visibleSize: this.sellIcebergNum + ""
      };

      API.insertLimitOrder(data).then((res) => {
        if (res.data.errcode === 0) {
          if (this.activetabName === "first") {
            this.getAccounts();
            this.getOrders("active", "1");
          } else if (this.activetabName === "second") {
            this.getAccounts();
            this.getFills("1");
          }
          this.$message({
            message: "下单成功！",
            type: "success"
          });
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            this.$router.push("/login");
          }
        }
      });

      this.timeoutNum += 1;

      setTimeout(() => {
        this.batchOrderSell();
      }, 200);
    }
  },

  /**
   *初始阶段
   */
  async created() {
    // 获取交易所列表
    await this.getExchangesList();
    if (this.activetabName === "first") {
      this.isCancelBtn = true;
    } else {
      this.isCancelBtn = false;
    }
    this.init();
  },

  /**
   * 挂载
   */
  mounted() {
    // if (window.performance.navigation.type == 1){
    //        console.log("页面被刷新");
    //        this.getMenuData();
    //    }
    // tab表格自适应高度
    var tableDiv = document.getElementById("tableDiv");
    this.tableHeight = tableDiv.offsetHeight - 63;
    // 浏览器大小改变时触发
    window.onresize = function () {
      if (tableDiv) {
        this.tableHeight = tableDiv.offsetHeight - 63;
      }
    }.bind(this);
    //this.$refs.askTableRef1.bodyWrapper.scrollTop = this.$refs.askTableRef1.bodyWrapper.scrollHeight;
    this.$nextTick(() => {
      const table = this.$refs.askTableRef;
      if (table) {
        table.bodyWrapper.scrollTop = table.bodyWrapper.scrollHeight;

        // const lastRow = table.rows.item(table.rows.length - 1);
        // lastRow.scrollIntoView();
      }
    });
  },

  /**
   * 销毁
   */
  destroyed() {
    var self = this;
    clearInterval(self.getDeepDataInterval);
    // this.$WS.websocketClose()
  }
};
</script>

<style scoped>
@import "../assets/css/index.scss";
@import "../assets/css/trade.scss";

.layoutModule_shell {
  position: absolute;
  left: 0px;
  top: 45px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 89%;
}

.containrightupleft_all {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 80%;
  height: 100%;
  overflow: auto;
}
</style>
